<template>
  <div class="content mt-n4" :id="compoID">
    <div class="md-layout">
      <!-- layout1 -->
      <div class="md-layout-item md-medium-size-100 md-size-50">
        <!-- row 1 -->
        <v-row class="mt-5">
          <v-col cols="1" class="mt-3">
            <v-icon @click="toggleSidebar()"> mdi-dots-vertical </v-icon>
          </v-col>
          <v-col cols="5" class="ml-n9">
            <v-text-field
              style="border-radius: 12px"
              v-model="fileName"
              filled
              dense
              label="File name"
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" class="mt-n2">
            <v-row class="ma-0 pa-0" justify="start">
              <v-icon class="ml-n2">mdi-delete-outline </v-icon>
              <v-icon class="ml-2">mdi-pencil-outline</v-icon>
              <v-checkbox class="ml-2 mt-4" v-model="fileNameChecked">
              </v-checkbox>
              <p
                class="mt-5"
                style="font-size: 16px; opacity: 0.8; font-weight: 800"
              >
                File name
              </p>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="ml-6 mt-n6"></v-divider>
        <!-- row2 -->
        <v-row class="ma-0 pa-0 mt-2 ml-6">
          <p style="font-weight: 800; opacity: 0.8">
            Description
            <v-icon
              style="cursor: pointer"
              @click="description = !description"
              v-if="!description"
              >mdi-menu-right</v-icon
            >
            <v-icon
              style="cursor: pointer"
              @click="description = !description"
              v-if="description"
              >mdi-menu-down</v-icon
            ><v-icon @click="description = true">mdi-plus</v-icon>
          </p>
        </v-row>
        <v-row v-if="description">
          <v-col cols="1"></v-col>

          <v-col cols="6">
            <v-textarea
              style="border-radius: 12px"
              v-model="filedescription"
              filled
              auto-grow
              label="Description"
              rows="4"
              row-height="15"
              rounded
            ></v-textarea>
          </v-col>
          <v-col> </v-col>
        </v-row>
        <v-divider class="ml-6 mt-n1"></v-divider>
        <!-- row3 -->
        <v-row class="ma-0 pa-0 mt-2 ml-6">
          <p style="font-weight: 800; opacity: 0.8">
            Progress
            <v-icon
              style="cursor: pointer"
              @click="progress = !progress"
              v-if="!progress"
              >mdi-menu-right
            </v-icon>
            <v-icon
              style="cursor: pointer"
              @click="progress = !progress"
              v-if="progress"
              >mdi-menu-down
            </v-icon>
            <v-icon>mdi-plus</v-icon>
          </p>
        </v-row>
        <v-row v-if="progress" class="ml-3">
          <v-col cols="1"></v-col>
          <v-col>
            <v-row>
              <v-banner
                :dark="lightTheme"
                :light="darkTheme"
                color="#E5E4E2"
                width="2"
                height="11"
                class="ma-0 pa-0 mr-1 mt-1"
              >
              </v-banner>
              <div class="ma-0 pa-0 mt-2">
                <v-row justify="center">
                  <v-banner
                    :dark="lightTheme"
                    :light="darkTheme"
                    width="34"
                    height="2"
                    style=""
                    color="#E5E4E2"
                  >
                  </v-banner>
                  <v-icon size="20" class="mt-n2" color="blue"
                    >mdi-circle-outline</v-icon
                  >
                  <v-banner
                    :dark="lightTheme"
                    :light="darkTheme"
                    width="34"
                    height="2"
                    style=""
                    color="#E5E4E2"
                  >
                  </v-banner>
                </v-row>
                <v-row justify="center" v-if="progress" class="mt-1">
                  <p style="text-align: center">Asset Uploaded</p>
                </v-row>
                <v-row justify="center" v-if="progress" class="mt-n2">
                  <p
                    style="
                      text-align: center;
                      font-size: 10px;
                      font-weight: 600;
                    "
                  >
                    04.01.2020
                  </p>
                </v-row>
              </div>
              <v-icon size="25" style="margin-top: -2.17em" class="ml-n2"
                >navigate_next</v-icon
              >
            </v-row>
          </v-col>
        </v-row>

        <v-divider class="ml-6 mt-n1"></v-divider>
        <!-- row4 -->
        <v-row class="ma-0 pa-0 mt-2 ml-6">
          <p style="font-weight: 800; opacity: 0.8">
            Status
            <v-icon
              style="cursor: pointer"
              @click="status = !status"
              v-if="!status"
              >mdi-menu-right
            </v-icon>
            <v-icon
              style="cursor: pointer"
              @click="status = !status"
              v-if="status"
              >mdi-menu-down
            </v-icon>
          </p>
        </v-row>
        <v-row v-if="status" class="ml-1">
          <v-col cols="1"></v-col>
          <v-col>
            <div style="display: flex" class="ma-0 pa-0 mt-2">
              <div v-for="(item, index) in localStatus" :key="index">
                <v-row class="ma-0 pa-0" justify="center">
                  <show-at breakpoint="mediumAndBelow">
                    <div class="ma-0 pa-0">
                      <v-banner
                        :dark="lightTheme"
                        :light="darkTheme"
                        class="mt-3"
                        color="grey"
                        width="30"
                        height="1"
                      ></v-banner>
                    </div>
                  </show-at>
                  <hide-at breakpoint="mediumAndBelow">
                    <div class="ma-0 pa-0">
                      <v-banner
                        :dark="lightTheme"
                        :light="darkTheme"
                        class="mt-3"
                        color="grey"
                        width="50"
                        height="1"
                      ></v-banner>
                    </div>
                  </hide-at>
                  <v-icon
                    class=""
                    size="24"
                    color="grey"
                    @click="changeStatus(item)"
                  >
                    mdi-circle-outline</v-icon
                  >
                  <v-icon
                    v-if="item.value"
                    class="ml-n6"
                    size="24"
                    color="blue"
                  >
                    mdi-circle-medium</v-icon
                  >
                  <show-at breakpoint="mediumAndBelow">
                    <div class="ma-0 pa-0">
                      <v-banner
                        :dark="lightTheme"
                        :light="darkTheme"
                        class="mt-3"
                        color="grey"
                        width="30"
                        height="1"
                      ></v-banner>
                    </div>
                  </show-at>
                  <hide-at breakpoint="mediumAndBelow">
                    <div class="ma-0 pa-0">
                      <v-banner
                        :dark="lightTheme"
                        :light="darkTheme"
                        class="mt-3"
                        color="grey"
                        width="50"
                        height="1"
                      ></v-banner>
                    </div>
                  </hide-at>
                </v-row>
                <v-row justify="center">
                  <p style="font-size: 12px; font-weight: 700; opacity: 0.6">
                    {{ item.title }}
                  </p>
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-divider class="ml-6 mt-n1"></v-divider>
        <!-- row5 -->
        <v-row class="ma-0 pa-0 mt-2 ml-6">
          <p
            class="ma-0 pa-0 mt-n2 mb-1"
            style="font-weight: 800; opacity: 0.8"
          >
            Tags
            <v-icon
              style="cursor: pointer"
              @click="tagsonoff = !tagsonoff"
              v-if="!tagsonoff"
              >mdi-menu-right
            </v-icon>
            <v-icon
              style="cursor: pointer"
              @click="tagsonoff = !tagsonoff"
              v-if="tagsonoff"
              >mdi-menu-down
            </v-icon>

            <v-menu
              rounded="xl"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="210"
            >
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon> mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card
                elevation="0"
                rounded="xl"
                width="210"
                style="overflow: hidden"
                height="220"
                class="ma-0 pa-0"
              >
                <div style="display: flex" class="pl-4">
                  <h4 style="font-weight: 670">Assign Tags</h4>
                  <v-content class="pl-10 pt-3">
                    <manageTag />
                  </v-content>
                </div>
                <v-text-field
                  v-model="searchTag"
                  class="pl-3 pr-3"
                  outlined
                  rounded="lg"
                  dense
                  append-icon="search"
                  label="Find Tags"
                >
                </v-text-field>
                <v-card
                  elevation="0"
                  width="190"
                  height="140"
                  style="overflow-x: hidden"
                  class="mt-n4 ml-2 pr-2 expand"
                >
                  <v-row class="ml-2 mr-3">
                    <div v-for="(item, index) in localtags" :key="index">
                      <v-chip
                        small
                        @click="tagpass(item.title, item.color)"
                        class="ml-3 mt-2"
                        :color="item.color"
                        >{{ item.title }}
                      </v-chip>
                    </div>
                  </v-row>
                </v-card>
              </v-card>
            </v-menu>

            <v-icon>search</v-icon>
          </p>
        </v-row>
        <v-row class="mt-n4" v-if="tagsonoff">
          <v-col cols="1"></v-col>
          <v-col>
            <v-card
              color="transparent"
              elevation="0"
              tile
              width="240"
              min-height="20"
              class="expand mt-n1"
            >
              <v-row class="ml-2 mr-3">
                <div v-for="(item, index) in selectedTags" :key="index">
                  <v-chip small class="ml-2 mt-1" :color="item.color"
                    >{{ item.title }}
                  </v-chip>
                </div>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-divider class="ml-6 mt-n1"></v-divider>
        <!-- row6 -->
        <v-row class="ma-0 pa-0 mt-2 ml-6">
          <p style="font-weight: 800; opacity: 0.8">
            Versions
            <v-icon
              style="cursor: pointer"
              @click="versions = !versions"
              v-if="!versions"
              >mdi-menu-right</v-icon
            >
            <v-icon
              style="cursor: pointer"
              @click="versions = !versions"
              v-if="versions"
              >mdi-menu-down</v-icon
            >

            <v-icon>mdi-plus</v-icon>
          </p>
        </v-row>
        <!-- <v-row class="mt-n5" v-if="versions">
          <div class="ma-0 pa-0">
            <v-row class="ma-0 pa-0 ml-15">
              <v-col cols="1"></v-col>
              <v-col>
                <v-row>
                  <div style="display: flex">
                    <div class="ma-0 pa-0">
                      <v-row class="ma-0 pa-0" justify="center">
                        <div class="ma-0 pa-0">
                          <v-row justify="center">
                            <v-img
                              rounded
                              contain
                              aspect-ratio="1"
                              width="70"
                              height="70"
                              src="/static/assets/images/screenshot.png"
                            ></v-img>
                          </v-row>
                          <v-row justify="center" class="mt-n3">
                            <h6>V01</h6>
                          </v-row>
                          <v-row justify="center" class="mt-n3">
                            <p style="font-size: 9px; font-weight: 200">
                              04.11.2020
                            </p>
                          </v-row>
                          <v-row justify="center" class="mt-n6">
                            <v-checkbox></v-checkbox
                          ></v-row>
                        </div>
                      </v-row>
                    </div>
                  </div>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="ma-0 pa-0 mt-n9">
              <v-col cols="1"> </v-col
              ><v-col
                ><p style="font-size: 10px; font-weight: 200">
                  Detected version
                </p></v-col
              >
            </v-row>
          </div>
        </v-row> -->

        <v-divider class="ml-6 mt-n1"></v-divider>
        <!-- row 7 -->
        <v-row class="ma-0 pa-0 mt-2 ml-6">
          <p style="font-weight: 800; opacity: 0.8">
            Colors
            <v-icon
              style="cursor: pointer"
              @click="colors = !colors"
              v-if="!colors"
              >mdi-menu-right</v-icon
            >
            <v-icon
              style="cursor: pointer"
              @click="colors = !colors"
              v-if="colors"
              >mdi-menu-down</v-icon
            >

            <v-icon>mdi-plus</v-icon>
          </p>
        </v-row>
        <v-row v-if="colors" class="mt-n8 ml-4">
          <v-col cols="1"></v-col>
          <v-col>
            <v-card
              elevation="4"
              width="30"
              height="30"
              style="border-radius: 50% !important"
            >
            </v-card>
          </v-col>
        </v-row>
        <v-divider class="ml-6 mt-n1"></v-divider>
        <!-- row 8 -->
        <v-row class="ma-0 pa-0 mt-2 ml-6">
          <p style="font-weight: 800; opacity: 0.8">
            User
            <v-icon style="cursor: pointer" @click="user = !user" v-if="!user"
              >mdi-menu-right</v-icon
            >
            <v-icon style="cursor: pointer" @click="user = !user" v-if="user"
              >mdi-menu-down</v-icon
            >

            <v-icon>mdi-plus</v-icon>
          </p>
        </v-row>
        <v-row v-if="user">
          <v-col cols="1"></v-col>
          <v-col>
            <!-- <div style="display: flex">
              <div>
                <v-row justify="center" v-if="user">
                  <v-avatar class="">
                    <img
                      src="https://cdn.vuetifyjs.com/images/john.jpg"
                      alt="John"
                    />
                  </v-avatar>
                </v-row>
                <v-row justify="center" class="mt-n5" v-if="user">
                  <v-list
                    :style="{
                      background: $vuetify.theme.themes[theme].background,
                    }"
                  >
                    <v-list-item-content>
                      <p
                        style="
                          font-size: 10px;
                          font-weight: 620;
                          text-align: center;
                        "
                        class="mt-1"
                      >
                        Timothy
                      </p>
                      <p style="font-size: 8px; text-align: center">
                        01.04.2020
                      </p>
                      <p style="font-size: 7px; text-align: center">inactive</p>
                    </v-list-item-content>
                  </v-list>
                </v-row>
              </div>
            </div> -->
          </v-col>
        </v-row>
        <!-- <v-row>
         
        </v-row>
        <v-row justify="center" class="mt-3">
          <v-btn outlined text @click="goBackToFiles">Back</v-btn>
          
        </v-row> -->
        <v-divider class="ml-6 mt-n1"></v-divider>
        <!-- row 9 -->

        <div class="mt-5" style="display: flex; justify-content: space-between">
          <p
            style="font-weight: 800; opacity: 0.8; cursor: pointer"
            @click="goBackToFiles"
          >
            <v-icon>arrow_left</v-icon>Back to Asset Overview
          </p>
          <v-card-subtitle class="mt-n3" style="color: red" v-if="error">{{
            errorMsg
          }}</v-card-subtitle>
          <v-btn class="ml-3 mt-n1" outlined text @click="addFileToServer"
            >Submit</v-btn
          >
          <v-btn
            v-if="importType === 'draco'"
            text
            class="ml-2 mt-n1"
            outlined
            @click="compressFileToServer"
            >Compress</v-btn
          >
        </div>

        <!-- <v-card
          class="mx-auto my-12"
          :style="{
            background: $vuetify.theme.themes[theme].background,
          }"
        >
          <template slot="progress">
            <v-progress-linear
              color="#cccccc"
              indeterminate
            ></v-progress-linear>
          </template> -->
        <!--
          <div
            v-bind:class="[isActive ? 'mainARview' : 'mainARview1']"
            style="height:20vh; min-height:20vh;"
          >
            <div class="drop-zone" v-on:dblclick="addAnnotation()">
              <v-btn class="drop-zone__prompt" icon>
                <v-icon @click="inputFileClick()">mdi-cloud-upload</v-icon>
              </v-btn>

              
              <input
                type="file"
                name="ARfile"
                id="rr1"
                @change="changeScene()"
                class="drop-zone__input"
              />
            </div>
          </div>
          -->
        <!-- <v-card-title class="headline">Enter File Info</v-card-title>
          <v-divider class="mx-4"></v-divider>
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-size-15"></div>

            <div class="md-layout-item md-medium-size-100 md-size-70 ma-4">
              <v-form ref="form">
                <v-text-field
                  v-model="fileName"
                  outlined
                  label="Name"
                  :rules="[rules.required, rules.minName, rules.maxName]"
                ></v-text-field>
                <v-textarea
                  v-model="filedescription"
                  label="Description"
                  auto-grow
                  outlined
                  rows="2"
                  row-height="15"
                ></v-textarea>

                <v-divider class="mx-4"></v-divider>
                <v-menu
                  v-model="menu"
                  bottom
                  right
                  transition="scale-transition"
                  origin="top left"
                >
                  <template v-slot:activator="{ on }">
                    <v-chip v-on="on" :color="getStateColor(selected)" dark>{{
                      selected
                    }}</v-chip>
                    <v-card-subtitle>State</v-card-subtitle>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="item in state"
                      :key="item"
                      :disabled="loading"
                      @click="selected = item"
                    >
                      <v-list-item-title v-text="item"></v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-divider class="mx-4 mt-4"></v-divider>
                <v-menu
                  v-model="menu"
                  bottom
                  right
                  transition="scale-transition"
                  class="ma-5"
                  origin="top left"
                >
                  <template v-slot:activator="{ on }">
                    <v-chip v-on="on" :color="getTagsColor(selectedTag)" dark>{{
                      selectedTag
                    }}</v-chip>
                    <v-card-subtitle>Tag</v-card-subtitle>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="item in tags"
                      :key="item"
                      :disabled="loading"
                      @click="selectedTag = item"
                    >
                      <v-list-item-title v-text="item"></v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-form>
            </div>

            <div class="md-layout-item md-medium-size-100 md-size-15"></div>
          </div>
          <v-card-subtitle style="color: red" v-if="error">{{
            errorMsg
          }}</v-card-subtitle>
          <v-divider class="mx-4 mt-4"></v-divider>

          <v-card-actions>
            <v-btn color="deep-purple lighten-2" text @click="goBackToFiles"
              >Back</v-btn
            >
            <v-btn color="deep-purple lighten-2" text @click="addFileToServer"
              >Submit</v-btn
            >
            <v-btn
              v-if="importType === 'draco'"
              color="deep-purple lighten-2"
              text
              @click="compressFileToServer"
              >Compress</v-btn
            >
            
          </v-card-actions>
        </v-card> -->
      </div>
      <!-- layout2 -->
      <div
        class="
          md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50
          mt-7
        "
      >
        <div class="md-layout ma-0 pa-0 mr-n4">
          <!-- first half -->
          <div
            class="
              md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100
            "
            style="position: relative"
          >
            <v-card
              style="width: 100%; min-height: 50vh; border-radius: 20px"
              elevation="6"
            >
              <fullscreen
                id="Zoom1"
                ref="fullscreen"
                :fullscreen.sync="fullscreen"
                @change="fullscreenChange"
              >
                <augmentable-viewer
                  ref="model"
                  :id="computedCompoID"
                  @on-model-load="generateThumbnail()"
                  style="height: 50vh; min-height: 50vh"
                ></augmentable-viewer>
                <!-- <div class="drop-zone">
                  <v-btn
                    v-if="augmentableTheme"
                    class="drop-zone__prompt"
                    @click="inputFileClick()"
                    icon
                  >
                    <md-icon
                      class="md-size-3x"
                      md-src="/static/assets/svg/white/Upload.svg"
                    ></md-icon>
                  </v-btn>

                  <v-btn
                    v-if="!augmentableTheme"
                    class="drop-zone__prompt"
                    @click="inputFileClick()"
                    icon
                  >
                    <md-icon
                      class="md-size-3x"
                      md-src="/static/assets/svg/black/Upload.svg"
                    ></md-icon>
                  </v-btn>

                  <input
                    type="file"
                    name="ARfile"
                    id="rr1"
                    @change="changeScene()"
                    class="drop-zone__input"
                  />
                </div> -->

                <div v-if="fullscreen">
                  <v-btn
                    icon
                    light
                    @click="toggleFullScreen()"
                    style="
                      position: absolute !important;
                      z-index: 2;
                      right: 4em;
                      bottom: 1.4em;
                    "
                  >
                    <md-icon
                      class="md-size-2x"
                      md-src="/static/assets/svg/black/Exit Fullscreen.svg"
                    ></md-icon>
                  </v-btn>
                </div>
              </fullscreen>

              <v-btn
                icon
                light
                @click="toggleFullScreen()"
                style="
                  position: absolute !important;
                  z-index: 2;
                  right: 1em;
                  bottom: 0.8em;
                "
              >
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/black/Fullscreen.svg"
                ></md-icon>
              </v-btn>
              <!-- <v-btn
                icon
                x-large
                v-on:click="hdrSettings = !hdrSettings"
                style="
                  position: absolute !important;
                  z-index: 1000;
                  left: 1em;
                  top: 0.8em;
                  cursor: pointer;
                "
              >
                <md-icon
                  class="md-size-2x"
                  md-src="/static/assets/svg/black/Settings.svg"
                ></md-icon>
              </v-btn> -->
              <!-- start viewer settings component -->
              <div v-if="hdrSettings" class="hdrNavigation ma-0 pa-0 ml-5 mt-5">
                <v-container class="ma-0 pa-0">
                  <v-card
                    width="252"
                    elevation="3"
                    min-height="310"
                    style="border-radius: 15px"
                    :style="{
                      background: $vuetify.theme.themes[theme].background,
                    }"
                  >
                    <v-layout>
                      <v-flex>
                        <v-card
                          width="30"
                          elevation="0"
                          height="320"
                          class="ml-1"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                        >
                          <!-- 1st btn -->
                          <div class="ma-0 pa-0">
                            <v-row class="ma-0 pa-0 mt-n3 ml-2">
                              <v-btn icon>
                                <v-icon size="22" @click="lightf()">
                                  mdi-lightbulb-on-outline
                                </v-icon>
                              </v-btn>
                            </v-row>
                            <!-- 2nd btn -->
                            <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <v-btn icon>
                                <v-icon size="22" @click="circlef()">
                                  tonality
                                </v-icon>
                              </v-btn>
                            </v-row>
                            <!-- 3rd btn -->
                            <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <v-btn icon>
                                <v-icon size="22" @click="mediaf()">
                                  mdi-play-circle-outline
                                </v-icon>
                              </v-btn>
                            </v-row>
                            <!-- 4th btn -->
                            <!-- <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <v-btn @click="colorbtnf()" icon>
                                <v-icon size="22"> mdi-palette-outline </v-icon>
                              </v-btn>
                            </v-row> -->
                            <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn icon v-on="on">
                                    <v-icon size="22" @click="boxbtnf()">
                                      mdi-palette-outline
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Beta 1.2</span>
                              </v-tooltip>
                            </v-row>

                            <!-- 5th btn -->
                            <!-- <v-row class="ma-0 pa-0 mt-3 ml-2"> -->
                            <!-- <v-btn @click="boxbtnf()" icon> -->
                            <!-- <v-btn icon>
                                <v-icon size="22"> mdi-texture </v-icon>
                              </v-btn>
                            </v-row> -->
                            <!-- 5th btn -->
                            <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn icon v-on="on">
                                    <v-icon size="22" @click="filebtnf()">
                                      description
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Beta 1.2</span>
                              </v-tooltip>
                            </v-row>
                            <!-- 6th btn -->
                            <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn icon v-on="on">
                                    <v-icon size="22" @click="photobtnf()">
                                      photo_size_select_large
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Beta 1.2</span>
                              </v-tooltip>
                            </v-row>
                            <!-- 7th btn -->
                            <v-row class="ma-0 pa-0 mt-3 ml-2">
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <v-btn icon v-on="on">
                                    <v-icon size="22"> mdi-undo </v-icon>
                                  </v-btn>
                                </template>
                                <span>Beta 1.2</span>
                              </v-tooltip>
                            </v-row>
                          </div>
                        </v-card>
                      </v-flex>

                      <v-divider
                        class="mt-2 mb-5"
                        style="border-color: #d3d3d3"
                        vertical
                      ></v-divider>

                      <v-flex>
                        <!-- 1st card -->
                        <v-card
                          v-if="lightbutton"
                          width="170"
                          elevation="0"
                          min-height="300"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-4 ml-2"
                        >
                          <p
                            class="caption-11 ml-3"
                            style="font-weight: 700; opacity: 0.8"
                          >
                            Enviorment
                          </p>
                          <p
                            class="ml-3"
                            style="font-size: 11px; font-weight: 650"
                          >
                            Active HDR (Share Page)
                          </p>

                          <v-select
                            :items="hdrFileItems"
                            v-model="hdrItem"
                            item-text="file_name"
                            item-value="file_hdr"
                            dense
                            class="ml-1 mt-n2"
                            rounded
                            outlined
                            @input="hdrSelectActive(hdrItem)"
                          >
                          </v-select>

                          <v-row>
                            <v-col cols="9">
                              <p
                                class="caption-11"
                                style="
                                  font-weight: 700;
                                  opacity: 0.8;
                                  margin-top: -2.2em;
                                "
                              >
                                Use Enviorment as skyBox
                              </p>
                            </v-col>
                            <v-col cols="2">
                              <v-checkbox
                                v-model="asSkybox"
                                style="margin-top: -2.2em"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="9">
                              <p
                                class="caption-11"
                                style="
                                  font-weight: 700;
                                  opacity: 0.8;
                                  margin-top: -2.2em;
                                "
                              >
                                Neutral Light
                              </p>
                            </v-col>
                            <v-col cols="2">
                              <v-checkbox
                                v-model="neutralLight"
                                style="margin-top: -2.2em"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <p
                            class="caption-11"
                            style="
                              font-weight: 700;
                              opacity: 0.8;
                              margin-top: -1.3em;
                            "
                          >
                            HDRI light rotation
                          </p>
                          <v-slider
                            thumb-label
                            track-color="grey"
                            class="mt-n4"
                            track-fill-color="grey"
                          >
                          </v-slider>
                          <p
                            class="caption-11"
                            style="
                              font-weight: 700;
                              opacity: 0.8;
                              margin-top: -2em;
                            "
                          >
                            Brightness
                          </p>
                          <v-slider
                            v-model="hdrExposure"
                            thumb-label
                            min="0"
                            max="2"
                            step="0.1"
                            class="mt-n4"
                            track-color="grey"
                            track-fill-color="grey"
                          >
                          </v-slider>
                          <!-- <p
                            class="caption-11"
                            style="
                              font-weight: 700;
                              opacity: 0.8;
                              margin-top: -2em;
                            "
                          >
                            Brightness
                          </p>
                          <v-slider
                            thumb-label
                            track-color="grey"
                            class="mt-n4"
                            track-fill-color="grey"
                          >
                          </v-slider> -->
                          <v-row class="mt-n8">
                            <v-col cols="6">
                              <p
                                class="caption-11"
                                style="font-weight: 700; opacity: 0.8"
                              >
                                HDR List
                              </p>
                            </v-col>
                            <v-col cols="3">
                              <v-icon
                                @click="hdrlist = !hdrlist"
                                color="blue"
                                class="ml-n5"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                            <v-col cols="2">
                              <v-icon size="22" @click="addHDR()"
                                >mdi-plus</v-icon
                              >
                            </v-col>
                          </v-row>
                          <div v-if="hdrlist">
                            <v-card
                              elevation="0"
                              height="130"
                              class="expand mt-n3"
                              :style="{
                                background:
                                  $vuetify.theme.themes[theme].background,
                              }"
                            >
                              <v-card-text>
                                <div
                                  v-for="(item, index) in hdrFileItems"
                                  :key="index"
                                >
                                  <v-row class="ma-0 pa-0">
                                    <v-col cols="8">
                                      <p
                                        style="cursor: pointer"
                                        @click="hdrSelect(item.file_hdr)"
                                      >
                                        {{ item.file_name }}
                                      </p>
                                    </v-col>
                                    <v-col cols="4">
                                      <v-btn icon @click="deleteHDR(item.id)">
                                        <v-icon> mdi-delete-outline </v-icon>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                  <v-divider
                                    style="border-color: #d3d3d3"
                                    class="ml-2 mr-2"
                                  ></v-divider>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                        </v-card>

                        <!-- 2nd card -->
                        <v-card
                          v-if="circlebutton"
                          width="170"
                          elevation="0"
                          min-height="280"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-n3 ml-2"
                        >
                          <p
                            class="caption-11 mt-8"
                            style="font-weight: 700; opacity: 0.8"
                          >
                            Shadow Intensity
                          </p>
                          <div class="ma-0 pa-0" style="display: flex">
                            <v-slider
                              class="mt-n5"
                              v-model="shadowIntensity"
                              min="0.0"
                              step="0.1"
                              max="10.0"
                              thumb-label
                              track-color="grey"
                              track-fill-color="grey"
                            >
                            </v-slider>
                            <p
                              class="caption-11 mt-n5"
                              style="font-weight: 700; opacity: 0.8"
                            >
                              {{ computedShadowIntensity }}
                              <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn>
                            </p>
                          </div>
                          <p
                            class="caption-11 mt-n3"
                            style="font-weight: 700; opacity: 0.8"
                          >
                            Shadow Softness
                          </p>
                          <div class="ma-0 pa-0" style="display: flex">
                            <v-slider
                              class="mt-n5"
                              v-model="shadowSoftness"
                              min="0.0"
                              step="0.1"
                              max="1.0"
                              thumb-label
                              track-color="grey"
                              track-fill-color="grey"
                            >
                            </v-slider>
                            <p
                              class="caption-11 mt-n5"
                              style="font-weight: 700; opacity: 0.8"
                            >
                              {{ computedShadowSoftness }}
                              <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn>
                            </p>
                          </div>

                          <!-- <p
                            class="caption-11 mt-n3"
                            style="font-weight: 700; opacity: 0.8"
                          >
                            Contrast
                          </p>
                          <v-slider
                            class="mt-n5"
                            thumb-label
                            track-color="grey"
                            track-fill-color="grey"
                          >
                          </v-slider> -->
                          <!-- <p
                            class="caption-11 mt-n3"
                            style="font-weight: 700; opacity: 0.8"
                          >
                            Saturation
                          </p>
                          <v-slider
                            class="mt-n5"
                            thumb-label
                            track-color="grey"
                            track-fill-color="grey"
                          >
                          </v-slider> -->
                          <div style="display: flex" class="mt-n3">
                            <p>Wireframe</p>
                            <v-checkbox class="mt-n2 ml-8"></v-checkbox>
                          </div>
                          <div style="display: flex" class="mt-n3">
                            <p>Shaded</p>
                            <v-checkbox class="mt-n2 ml-13"></v-checkbox>
                          </div>
                          <div style="display: flex" class="mt-n3">
                            <p>Double Sided</p>
                            <v-checkbox class="mt-n2 ml-4"></v-checkbox>
                          </div>
                        </v-card>

                        <!-- 3 card -->
                        <v-card
                          v-if="mediabutton"
                          width="170"
                          elevation="0"
                          min-height="280"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-3 ml-2"
                        >
                          <v-row>
                            <v-col cols="10">
                              <p
                                class="caption-11"
                                style="font-weight: 700; opacity: 0.8"
                              >
                                Enable turnable
                              </p>
                            </v-col>
                            <v-col cols="1">
                              <v-checkbox
                                v-model="glbRotation"
                                class="ml-n2 mt-n1"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row style="margin-top: -3.3em">
                            <!-- <v-col cols="1">
                              <v-icon> sync </v-icon>
                            </v-col>
                            <v-col cols="1">
                              <v-icon> sync </v-icon>
                            </v-col> -->
                            <v-col cols="1">
                              <v-icon @click="directionClockWise = true">
                                mdi-axis-z-rotate-counterclockwise
                              </v-icon>
                            </v-col>
                            <v-col cols="1">
                              <v-icon @click="directionClockWise = false">
                                mdi-axis-z-rotate-clockwise
                              </v-icon>
                            </v-col>
                          </v-row>
                          <p
                            class="caption-11"
                            style="
                              font-weight: 700;
                              opacity: 0.8;
                              margin-top: -0.6em;
                            "
                          >
                            Speed
                          </p>

                          <v-slider
                            v-model="speedAndDirectionOfModel"
                            min="20"
                            max="800"
                            step="5"
                            class="mt-n3"
                            thumb-label
                            track-color="grey"
                            track-fill-color="grey"
                          >
                          </v-slider>
                          <v-row>
                            <v-col cols="10">
                              <p
                                class="caption-11"
                                style="
                                  font-weight: 700;
                                  opacity: 0.8;
                                  margin-top: -2.2em;
                                "
                              >
                                Enable animation
                              </p>
                            </v-col>
                            <v-col cols="1">
                              <v-checkbox
                                class="ml-n2"
                                v-model="glbAnimation"
                                style="margin-top: -2.2em"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="9">
                              <p
                                class="caption-11"
                                style="
                                  font-weight: 700;
                                  opacity: 0.8;
                                  margin-top: -3.2em;
                                "
                              >
                                Loop
                              </p>
                            </v-col>
                            <v-col cols="2">
                              <v-checkbox
                                class="ml-2"
                                v-model="animationLoop"
                                style="margin-top: -3em"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <p
                            class="caption-11"
                            style="
                              font-weight: 700;
                              opacity: 0.8;
                              margin-top: -2.2em;
                            "
                          >
                            Active Animation
                          </p>
                          <v-row class="mt-n2">
                            <v-select
                              :items="animationList"
                              v-model="animationSelect"
                              dense
                              class="ml-2"
                              rounded
                              outlined
                              @input="animationSelected(animationSelect)"
                            >
                            </v-select>
                          </v-row>
                        </v-card>

                        <!-- 4 card -->

                        <v-card
                          v-if="colorbtncard"
                          width="170"
                          elevation="0"
                          min-height="280"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-3 ml-2"
                        >
                          <v-flex class="ma-0 pa-0">
                            <v-avatar
                              class="mt-4 mr-4 ml-4"
                              v-for="(item, index) in itemscolor"
                              :key="index"
                              :color="item.color"
                              @click="colorf(item)"
                              size="16"
                            ></v-avatar>
                          </v-flex>
                        </v-card>

                        <!-- 5 card -->
                        <v-card
                          v-if="boxbtncard"
                          width="170"
                          elevation="0"
                          min-height="370"
                          max-height="500"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-3 ml-2 expand1"
                        >
                          <v-row class="">
                            <v-col cols="7">
                              <p class="caption-11 pl-2">Materials</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon class="mt-n2">search</v-icon>
                            </v-col>
                            <v-col cols="1">
                              <v-menu
                                offset-y
                                left
                                min-width="145"
                                rounded="lg"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    class="mt-n2 ml-1"
                                    v-on="on"
                                    size="20"
                                    color="black"
                                    >mdi-plus</v-icon
                                  >
                                </template>
                                <v-card
                                  elevation="4"
                                  width="145"
                                  class="ma-0 pa-0"
                                  height="107"
                                  :style="{
                                    background:
                                      $vuetify.theme.themes[theme].background,
                                  }"
                                  rounded="lg"
                                >
                                  <div style="display: flex" class="pl-2 pt-2">
                                    <v-icon>mdi-content-copy</v-icon>
                                    <p
                                      style="font-weight: 450"
                                      class="pt-2 pl-2"
                                    >
                                      Duplicate
                                    </p>
                                  </div>
                                  <v-divider
                                    style="border-color: #d3d3d3"
                                    class="ml-2 mr-2"
                                  ></v-divider>
                                  <div style="display: flex" class="pl-2 pt-1">
                                    <v-icon class="mt-n2">mdi-plus</v-icon>
                                    <p
                                      style="font-weight: 450"
                                      class="ml-2 mt-1"
                                    >
                                      Create new
                                    </p>
                                  </div>
                                </v-card>
                              </v-menu>
                            </v-col>
                            <v-col cols="1"> </v-col>
                          </v-row>
                          <p
                            class="ml-2 mt-n6"
                            style="font-weight: 400 !important; font-size: 10px"
                          >
                            Select Material
                          </p>

                          <v-select
                            :items="items"
                            background-color="#F5F5F5"
                            solo
                            dense
                            style="border-radius: 1.5em !important"
                            label="material"
                            class="ml-1 mr-2 mt-n3 mb-n5"
                          >
                          </v-select>

                          <v-row class="ml-1 mt-n6">
                            <v-col cols="8">
                              <p class="caption-11">Transparency</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon
                                @click="transparency = !transparency"
                                size="22"
                                color="blue"
                                class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>
                          <div v-if="transparency" class="mt-n6">
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="ml-5"
                            >
                              Transparency Mode
                            </p>

                            <v-select
                              :items="items"
                              solo
                              dense
                              background-color="#F5F5F5"
                              label="material"
                              class="mb-n6 mt-n3 mr-2"
                              style="border-radius: 1.5em !important"
                            >
                            </v-select>
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="mt-2 ml-5"
                            >
                              Alpha Mode
                            </p>
                            <div>
                              <v-select
                                :items="items"
                                solo
                                dense
                                style="border-radius: 1.5em !important"
                                background-color="#F5F5F5"
                                label="material"
                                class="mb-n6 mt-n3 mr-2"
                              >
                              </v-select>
                            </div>
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="mt-2 ml-5"
                            >
                              Alpha
                            </p>
                            <v-slider class="mt-n5" thumb-label color="grey">
                            </v-slider>
                            <div style="display: flex" class="mt-n8 mb-n4">
                              <v-list
                                :style="{
                                  background:
                                    $vuetify.theme.themes[theme].background,
                                }"
                              >
                                <v-list-item style="font-size: 11px !important">
                                  Use alpha from albedo texture
                                </v-list-item>
                              </v-list>
                              <v-checkbox></v-checkbox>
                            </div>
                          </div>
                          <v-row class="ml-1 mt-n7">
                            <v-col cols="8">
                              <p class="caption-11">Base Color</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon size="22" color="blue" class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>

                          <v-row class="ml-1 mt-n7">
                            <v-col cols="8">
                              <p class="caption-11">Metalness</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon
                                @click="metalness = !metalness"
                                size="22"
                                color="blue"
                                class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>
                          <div v-if="metalness" class="mt-n6">
                            <div style="display: flex">
                              <v-menu offset-y min-width="100" rounded="lg">
                                <template v-slot:activator="{ on }">
                                  <v-card
                                    v-on="on"
                                    elevation="0"
                                    width="30"
                                    height="30"
                                    color="yellow"
                                    class="mt-2 ml-5"
                                  >
                                  </v-card>
                                </template>
                                <v-card
                                  elevation="5"
                                  rounded="lg"
                                  width="100"
                                  height="100"
                                  color="#F5F5F5"
                                  class="ma-0 pa-0"
                                >
                                  <p class="pt-2 pl-2" style="font-size: 12px">
                                    Textures
                                  </p>
                                </v-card>
                              </v-menu>
                              <p
                                style="font-size: 11px; font-weight: 500"
                                class="ml-3 mt-4"
                              >
                                Texture
                              </p>
                            </div>
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="ml-5"
                            >
                              Metalic Factor
                            </p>
                            <v-slider class="mt-n5" thumb-label color="grey">
                            </v-slider>
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="ml-5 mt-n6"
                            >
                              Roughness Factor
                            </p>
                            <v-slider
                              class="mt-n5 mb-n8"
                              thumb-label
                              color="grey"
                            >
                            </v-slider>
                          </div>

                          <v-row class="ml-1 mt-n7">
                            <v-col cols="8">
                              <p class="caption-11">Roughness</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon size="22" color="blue" class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>

                          <v-row class="ml-1 mt-n7">
                            <v-col cols="8">
                              <p class="caption-11">Occlusion</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon
                                @click="occlusion = !occlusion"
                                size="22"
                                color="blue"
                                class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>
                          <div v-if="occlusion" class="mt-n5">
                            <div style="display: flex">
                              <v-menu offset-y min-width="100" rounded="lg">
                                <template v-slot:activator="{ on }">
                                  <v-card
                                    v-on="on"
                                    elevation="0"
                                    width="30"
                                    height="30"
                                    color="blue"
                                    class="mt-2 ml-5"
                                  >
                                  </v-card>
                                </template>
                                <v-card
                                  elevation="5"
                                  rounded="lg"
                                  width="100"
                                  height="100"
                                  color="#F5F5F5"
                                  class="ma-0 pa-0"
                                >
                                  <p class="pt-2 pl-2" style="font-size: 12px">
                                    Textures
                                  </p>
                                </v-card>
                              </v-menu>
                              <p
                                style="font-size: 11px; font-weight: 500"
                                class="ml-3 mt-4"
                              >
                                Texture
                              </p>
                            </div>
                            <p
                              style="font-size: 10px; font-weight: 500"
                              class="ml-5"
                            >
                              Strength
                            </p>
                            <v-slider
                              class="mt-n5 mb-n8"
                              thumb-label
                              color="grey"
                            >
                            </v-slider>
                          </div>

                          <v-row class="ml-1 mt-n7">
                            <v-col cols="8">
                              <p class="caption-11">Normals</p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon size="22" color="blue" class="ml-n2"
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                          </v-row>
                        </v-card>

                        <!-- 6th card -->
                        <v-card
                          v-if="filebtncard"
                          width="170"
                          elevation="0"
                          min-height="280"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-3 ml-2"
                        >
                          <div v-for="(item, index) in filebtns" :key="index">
                            <v-row
                              class="ml-1 mb-3"
                              v-if="
                                item.name === 'Original File' && item.checked
                              "
                              style="
                                background-color: #b3e5fc;
                                height: 2.5em;
                                border-radius: 10px;
                                opacity: 0.8;
                              "
                              @click="selectviewerfile(index)"
                            >
                              <v-col cols="9">
                                <p
                                  class="caption-11 mt-n1"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                              </v-col>
                              <v-col cols="1"> </v-col>
                            </v-row>
                            <v-row
                              class="ml-1 mb-3"
                              v-if="
                                item.name === 'Original File' && !item.checked
                              "
                              @click="selectviewerfile(index)"
                              style="height: 2.5em"
                            >
                              <v-col cols="9">
                                <p
                                  class="caption-11 mt-n1"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                              </v-col>
                              <v-col cols="1"> </v-col>
                            </v-row>
                            <v-row
                              class="ml-1 mt-n1 mb-2"
                              style="
                                background-color: #b3e5fc;
                                height: 2.5em;
                                border-radius: 10px;
                                opacity: 0.8;
                              "
                              v-if="
                                item.checked && item.name !== 'Original File'
                              "
                              @click="selectviewerfile(index)"
                            >
                              <div style="display: flex" class="pl-2 mt-n1">
                                <md-icon
                                  v-if="augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg1"
                                />
                                <md-icon
                                  v-if="!augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg2"
                                />
                                <p
                                  class="caption-11 mt-3 ml-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                              </div>
                            </v-row>
                            <v-row
                              class="ml-1 mt-n1 mb-2"
                              v-if="
                                !item.checked && item.name !== 'Original File'
                              "
                              @click="selectviewerfile(index)"
                            >
                              <div style="display: flex" class="pl-2 mt-n1">
                                <md-icon
                                  v-if="augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg1"
                                />
                                <md-icon
                                  v-if="!augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg2"
                                />
                                <p
                                  class="caption-11 mt-3 ml-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                              </div>
                            </v-row>
                          </div>
                          <!-- <v-flex class="pt-2 pb-5">
                            <v-btn text style="width: 90%">
                              <p
                                class="caption-11 pt-2"
                                style="font-weight: 700; opacity: 0.8"
                              >
                                Original File
                              </p>
                            </v-btn>
                          </v-flex>
                          <v-row v-for="(item, index) in filebtns" :key="index">
                            <v-row
                              @click="checkExportFiles(item, index)"
                              class="mt-n8"
                            >
                              <v-col cols="1" class="ml-5">
                                <md-icon
                                  v-if="augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg1"
                                />
                                <md-icon
                                  v-if="!augmentableTheme"
                                  class="md-size-x"
                                  style="cursor: pointer"
                                  :md-src="item.svg2"
                                />
                              </v-col>
                              <v-col cols="6">
                                <p
                                  class="caption-11 mt-1 ml-2"
                                  style="
                                    font-weight: 700;
                                    opacity: 0.8;
                                    cursor: pointer;
                                  "
                                >
                                  {{ item.name }}
                                </p>
                              </v-col>
                              <v-col cols="1">
                                <v-checkbox class="mt-n1"></v-checkbox>
                              </v-col>
                              <v-col cols="1"> </v-col>
                            </v-row>
                          </v-row> -->
                        </v-card>
                        <!-- 7th card -->
                        <v-card
                          v-if="photobtncard"
                          width="170"
                          elevation="0"
                          min-height="340"
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          class="ma-0 pa-0 mt-3 ml-2"
                        >
                          <v-row class="">
                            <v-col cols="8">
                              <p class="ml-1 mt-n1 caption-11">
                                Resize Textures
                              </p>
                            </v-col>
                            <v-col cols="1">
                              <v-icon
                                class="mt-n2 ml-n2"
                                size="22"
                                color="primary"
                                @click="
                                  photomaterialtexture = !photomaterialtexture
                                "
                                >mdi-menu-down</v-icon
                              >
                            </v-col>
                            <v-col cols="1">
                              <v-checkbox class="mt-n2"></v-checkbox>
                            </v-col>
                            <v-col cols="1"> </v-col>
                          </v-row>

                          <div
                            v-if="photomaterialtexture"
                            class="ma-0 pa-0 mt-n14 ml-1 mb-8"
                          >
                            <p
                              style="font-size: 10px; font-weight: 450"
                              class="ml-2"
                            >
                              Texture Format
                            </p>
                            <v-select
                              rounded
                              outlined
                              dense
                              label="Same as Sourse"
                              class="mt-n3"
                              :item="textureitem"
                            >
                            </v-select>
                            <!-- <div
                    style="
                      display: flex;
                      height: 2.5em;
                      border-radius: 14px;
                      background-color: #e0e0e0;
                      opacity: 0.9;
                    "
                    class="mt-n4"
                  >
                    <p class="ml-2 mt-2" style="font-weight: 400">
                      Same as Sourse
                    </p>
                    <v-icon size="22" color="primary" class="mt-n1 ml-6"
                      >mdi-menu-down</v-icon
                    >
                  </div> -->
                          </div>
                          <p class="caption-11 mt-n14 ml-1">
                            Compression quality
                          </p>
                          <div class="ma-0 pa-0" style="display: flex">
                            <v-slider
                              class="mt-n5"
                              v-model="Compressionquality"
                              min="0.0"
                              step="0.1"
                              max="1.0"
                              thumb-label
                              track-color="grey"
                              track-fill-color="grey"
                            >
                            </v-slider>
                            <p
                              class="caption-11 mt-n4"
                              style="font-weight: 700; opacity: 0.8"
                            >
                              {{ computedCompressionquality }}
                              <!-- <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn> -->
                            </p>
                          </div>
                          <p class="caption-11 mt-n6 ml-1">Downsizing amount</p>
                          <div class="ma-0 pa-0" style="display: flex">
                            <v-slider
                              class="mt-n5"
                              v-model="Downsizingamount"
                              min="0.0"
                              step="0.1"
                              max="1.0"
                              thumb-label
                              track-color="grey"
                              track-fill-color="grey"
                            >
                            </v-slider>
                            <p
                              class="caption-11 mt-n4"
                              style="font-weight: 700; opacity: 0.8"
                            >
                              {{ computedDownsizingamount }}
                              <!-- <v-btn icon>
                                <v-icon> mdi-undo </v-icon>
                              </v-btn> -->
                            </p>
                          </div>
                          <v-card
                            elevation="0"
                            width="175"
                            height="250"
                            color="#e0e0e0"
                            rounded="xl"
                            class="mt-n4"
                          >
                            <div style="display: flex" class="pt-4 pl-4 pr-4">
                              <p style="font-size: 11px; font-weight: 570">
                                Texture Info
                              </p>
                              <v-spacer></v-spacer>
                              <v-icon size="24" class="mt-n2" color="black"
                                >mdi-information-outline</v-icon
                              >
                            </div>
                            <div style="display: flex" class="pl-7 pr-4">
                              <p class="caption-11">Format</p>
                              <v-spacer></v-spacer>
                              <p class="caption-11">PNG</p>
                            </div>
                            <div style="display: flex" class="pl-7 pr-4 mt-n1">
                              <p class="caption-11">Original</p>
                              <v-spacer></v-spacer>
                              <p class="caption-11">4096 px</p>
                            </div>
                            <div style="display: flex" class="pl-7 pr-4 mt-n1">
                              <p class="caption-11">Resized to</p>
                              <v-spacer></v-spacer>
                              <p style="color: #419cff" class="caption-11">
                                1434 px
                              </p>
                            </div>
                            <v-banner
                              color="#00897B"
                              height="1"
                              dark
                              width="175"
                              style="opacity: 0.4"
                            ></v-banner>
                            <div style="display: flex" class="pl-4 pr-4 pt-2">
                              <p style="font-size: 11px; font-weight: 570">
                                File Size
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px; font-weight: 570">
                                improved
                              </p>
                              <p
                                style="
                                  font-size: 11px;
                                  font-weight: 570;
                                  color: #419cff;
                                "
                              >
                                :33.33%
                              </p>
                            </div>
                            <div style="display: flex" class="pl-7 pr-4">
                              <p class="caption-11">Before:</p>
                              <v-spacer></v-spacer>
                              <p class="caption-11">12 mb</p>
                            </div>
                            <div style="display: flex" class="pl-7 pr-4 mt-n2">
                              <p class="caption-11">After:</p>
                              <v-spacer></v-spacer>
                              <p style="color: #419cff" class="caption-11">
                                8 mb
                              </p>
                            </div>
                          </v-card>
                          <div
                            class="ml-2 mb-3"
                            style="
                              height: 1.6em;
                              border-radius: 23px;
                              background-color: #419cff;
                              cursor: pointer;
                            "
                          >
                            <p style="text-align: center; color: white">
                              Apply
                            </p>
                          </div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-container>
              </div>
              <!-- end viewer settings component -->
            </v-card>
          </div>
          <!-- second half -->
          <div
            class="
              md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100
            "
          >
            <!-- <v-progress-linear color="blue" indeterminate></v-progress-linear> -->
            <md-card class="md-card-plain mt-n4 pb-15">
              <h2
                v-if="augmentableTheme"
                style="
                  color: white;
                  opacity: 0.8;
                  font-family: Nunito Sans;
                  font-size: 2rem !important;
                  font-weight: 1000 !important;
                "
              >
                Import
              </h2>
              <h2
                v-if="!augmentableTheme"
                style="
                  color: black;
                  opacity: 0.8;
                  font-family: Nunito Sans;
                  font-size: 2rem !important;
                  font-weight: 1000 !important;
                "
              >
                Import
              </h2>
              <div style="display: flex" class="mt-n3">
                <p class="category" style="font-size: 13px">
                  You can upload your files here, optimize is preselected check
                  for info
                </p>
                <v-spacer></v-spacer>
                <v-icon class="mt-n3">mdi-progress-question</v-icon>
              </div>
              <v-card
                :style="{ background: $vuetify.theme.themes[theme].background }"
                elevation="0"
                min-height="60"
                style="overflow: hidden"
                class="pl-1 mt-n3 ml-n2"
              >
                <div v-for="(item, index) in importFileItems" :key="index">
                  <v-row class="mb-n7">
                    <v-col cols="1">
                      <v-checkbox
                        class="mt-n1 ml-1"
                        v-model="item.checked"
                        @click="checkImportValues(item)"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="3" class="">
                      <p
                        class="caption-11 ml-1"
                        style="font-weight: 700; opacity: 0.8"
                      >
                        {{ item.title }}
                      </p>
                    </v-col>
                    <v-col cols="1" class="">
                      <v-menu
                        v-if="item.value == 'draco'"
                        rounded="xl"
                        :close-on-content-click="false"
                        top
                        offset-y
                        min-width="210"
                      >
                        <template v-slot:activator="{ on }">
                          <div style="cursor: pointer" v-on="on" class="ml-n3">
                            <v-icon @click="importmenu1 = true">
                              mdi-menu-down
                            </v-icon>
                          </div>
                        </template>
                        <v-card
                          :style="{
                            background: $vuetify.theme.themes[theme].background,
                          }"
                          elevation="0"
                          class="ma-0 pa-0 pb-2"
                          min-width="220"
                          min-height="80"
                          max-height="500"
                        >
                          <div class="ma-0 pa-0" style="display: flex">
                            <v-card
                              elevation="0"
                              color="transparent"
                              class="ma-0 pa-0"
                              min-width="220"
                              min-height="80"
                              max-height="500"
                            >
                              <v-row class="pt-2">
                                <v-col cols="1"></v-col>
                                <v-col cols="7">
                                  <p style="font-size: 11px; font-weight: 760">
                                    Optimized file settings
                                  </p>
                                </v-col>
                                <v-col cols="1">
                                  <v-icon class="mt-n1 ml-n1"
                                    >settings_input_component</v-icon
                                  >
                                </v-col>
                                <v-col cols="1"></v-col>
                              </v-row>
                              <v-row class="mt-n6">
                                <v-col cols="1"></v-col>
                                <v-col cols="6">
                                  <p style="font-size: 11px; font-weight: 660">
                                    Set File Format
                                  </p>
                                </v-col>
                                <v-col
                                  cols="1"
                                  style="cursor: pointer"
                                  @click="importmenu1 = !importmenu1"
                                >
                                  <v-icon
                                    class="ml-n7 mt-n2"
                                    v-if="!importmenu1"
                                  >
                                    mdi-menu-right
                                  </v-icon>
                                  <v-icon
                                    class="ml-n7 mt-n2"
                                    v-if="importmenu1"
                                  >
                                    mdi-menu-down
                                  </v-icon>
                                </v-col>
                              </v-row>
                              <v-row class="mt-n6">
                                <v-col cols="1"></v-col>
                                <v-col cols="6">
                                  <p style="font-size: 11px; font-weight: 600">
                                    Reduction Level
                                  </p>
                                </v-col>
                                <v-col
                                  cols="1"
                                  style="cursor: pointer"
                                  @click="importmenu1 = !importmenu1"
                                >
                                  <v-icon
                                    class="ml-n7 mt-n2"
                                    v-if="!importmenu1"
                                  >
                                    mdi-menu-right
                                  </v-icon>
                                  <v-icon
                                    class="ml-n7 mt-n2"
                                    v-if="importmenu1"
                                  >
                                    mdi-menu-down
                                  </v-icon>
                                </v-col>
                              </v-row>
                              <v-card
                                :style="{
                                  background:
                                    $vuetify.theme.themes[theme].background,
                                }"
                                v-if="importmenu1"
                                elevation="0"
                                width="180"
                                height="85"
                                class="ml-2 mt-n2"
                              >
                                <div
                                  style="display: flex"
                                  class="pa-0 ma-0 ml-6 mt-n4"
                                  v-for="(item, index) in quality"
                                  :key="index"
                                >
                                  <div class="ma-0 pa-0">
                                    <p style="font-size: 11px" class="ml-n2">
                                      {{ item.title }}
                                    </p>
                                  </div>
                                  <v-spacer></v-spacer>
                                  <div class="ma-0 pa-0">
                                    <p style="font-size: 11px">
                                      <v-icon
                                        style="margin-top: -0.1em"
                                        @click="minquality(item)"
                                        >navigate_before</v-icon
                                      >{{ item.value
                                      }}<v-icon
                                        style="margin-top: -0.1em"
                                        @click="maxquality(item)"
                                        >navigate_next</v-icon
                                      >
                                    </p>
                                  </div>

                                  <div class="ma-0 pa-0 mt-n1 mr-n2">
                                    <v-checkbox
                                      class="mt-n1"
                                      v-model="item.checked"
                                      @click="checkQualityValues(item)"
                                    ></v-checkbox>
                                  </div>
                                </div>
                              </v-card>
                              <!-- texture settings -->
                              <v-row class="mt-n6">
                                <v-col cols="1"></v-col>
                                <v-col cols="6">
                                  <p style="font-size: 11px; font-weight: 600">
                                    Texture Settings
                                  </p>
                                </v-col>
                                <v-col
                                  cols="1"
                                  style="cursor: pointer"
                                  @click="
                                    importmenutexture = !importmenutexture
                                  "
                                >
                                  <v-icon
                                    class="ml-n7 mt-n2"
                                    v-if="!importmenutexture"
                                  >
                                    mdi-menu-right
                                  </v-icon>
                                  <v-icon
                                    class="ml-n7 mt-n2"
                                    v-if="importmenutexture"
                                  >
                                    mdi-menu-down
                                  </v-icon>
                                </v-col>
                              </v-row>
                              <v-card
                                :style="{
                                  background:
                                    $vuetify.theme.themes[theme].background,
                                }"
                                v-if="importmenutexture"
                                elevation="0"
                                width="180"
                                height="85"
                                class="ml-2 mr-1 mt-n4"
                              >
                                <div
                                  class="ma-0 pa-0 ml-6"
                                  style="display: flex"
                                >
                                  <div class="ma-0 pa-0">
                                    <p style="font-size: 11px" class="ml-n2">
                                      Image Format
                                    </p>
                                  </div>
                                  <v-spacer></v-spacer>
                                  <div class="ma-0 pa-0">
                                    <p
                                      style="
                                        font-size: 12px;
                                        color: #419cff;
                                        margin-top: -3px;
                                      "
                                    >
                                      {{ selectedImageFormat }}

                                      <v-menu
                                        rounded="lg"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-x
                                        bottom
                                        max-width="100"
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-icon v-on="on">
                                            mdi-menu-down
                                          </v-icon>
                                        </template>
                                        <v-card
                                          class="ma-0 pa-0"
                                          width="100"
                                          height="100"
                                          rounded="lg"
                                          :style="{
                                            background:
                                              $vuetify.theme.themes[theme]
                                                .background,
                                          }"
                                          ><div class="pl-7 pr-7 pt-4 ma-0">
                                            <div
                                              class="ma-0 pa-0 mt-2"
                                              v-for="(
                                                item, i
                                              ) in selectedImageFormats"
                                              :key="i"
                                            >
                                              <p
                                                style="cursor: pointer"
                                                @click="
                                                  changeSelectedImageFormat(
                                                    item
                                                  )
                                                "
                                              >
                                                {{ item.text }}
                                              </p>
                                              <v-divider
                                                class="pl-5 pr-5 mt-n3"
                                                style="border-color: #d3d3d3"
                                              ></v-divider>
                                            </div>
                                          </div>
                                        </v-card>
                                      </v-menu>
                                    </p>
                                  </div>
                                </div>
                                <div
                                  class="ma-0 pa-0 ml-6 mt-n1"
                                  style="display: flex"
                                >
                                  <div class="ma-0 pa-0">
                                    <p style="font-size: 11px" class="ml-n2">
                                      Resolution
                                    </p>
                                  </div>
                                  <v-spacer></v-spacer>
                                  <div class="ma-0 pa-0">
                                    <p
                                      style="
                                        font-size: 12px;
                                        color: #419cff;
                                        margin-top: -3px;
                                      "
                                    >
                                      {{ selectedImageResolution }}

                                      <v-menu
                                        rounded="lg"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-x
                                        bottom
                                        max-width="150"
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-icon v-on="on">
                                            mdi-menu-down
                                          </v-icon>
                                        </template>
                                        <v-card
                                          class="ma-0 pa-0"
                                          width="150"
                                          height="200"
                                          rounded="lg"
                                          :style="{
                                            background:
                                              $vuetify.theme.themes[theme]
                                                .background,
                                          }"
                                          ><div class="pl-7 pr-7 pt-4 ma-0">
                                            <div
                                              class="ma-0 pa-0 mt-2"
                                              v-for="(
                                                item, i
                                              ) in selectedImageResolutions"
                                              :key="i"
                                            >
                                              <p
                                                style="cursor: pointer"
                                                @click="
                                                  changeSelectedImageResolution(
                                                    item
                                                  )
                                                "
                                              >
                                                {{ item.text }}
                                              </p>
                                              <v-divider
                                                class="pl-5 pr-5 mt-n3"
                                                style="border-color: #d3d3d3"
                                              ></v-divider>
                                            </div>
                                          </div>
                                        </v-card>
                                      </v-menu>
                                    </p>
                                  </div>
                                </div>

                                <div
                                  class="ma-0 pa-0 ml-6 mt-n1"
                                  style="display: flex"
                                >
                                  <div class="ma-0 pa-0">
                                    <p style="font-size: 11px" class="ml-n2">
                                      Bake Texture
                                    </p>
                                  </div>
                                  <v-spacer></v-spacer>

                                  <div class="ma-0 pa-0">
                                    <v-checkbox
                                      class="ma-0 pa-0 mr-n2 mt-n1"
                                      v-model="bakeTexture"
                                    ></v-checkbox>
                                  </div>
                                </div>
                              </v-card>
                              <v-row class="mt-n6">
                                <v-col cols="7">
                                  <p
                                    class="ml-6"
                                    style="font-size: 11px; font-weight: 600"
                                  >
                                    Set Compression
                                  </p>
                                </v-col>
                                <v-col
                                  cols="1"
                                  style="cursor: pointer"
                                  @click="importmenu2 = !importmenu2"
                                >
                                  <v-icon
                                    class="ml-n6 mt-n2"
                                    v-if="!importmenu2"
                                  >
                                    mdi-menu-right
                                  </v-icon>
                                  <v-icon
                                    class="ml-n6 mt-n2"
                                    v-if="importmenu2"
                                  >
                                    mdi-menu-down
                                  </v-icon>
                                </v-col>

                                <v-col cols="1" class="ml-1">
                                  <md-icon
                                    v-if="augmentableTheme"
                                    class="md-size-x ml-n2 mt-n1"
                                    md-src="/static/assets/svg/white/dracoIcon.svg"
                                  />
                                  <md-icon
                                    v-if="!augmentableTheme"
                                    class="md-size-x ml-n2 mt-n1"
                                    md-src="/static/assets/svg/black/dracoIcon.svg"
                                  />
                                </v-col>
                                <v-col
                                  cols="1"
                                  class="mr-2"
                                  style="cursor: pointer"
                                >
                                  <v-icon
                                    class="mt-n2 ml-n3"
                                    @click="importmenu3 = !importmenu3"
                                  >
                                    mdi-menu-right</v-icon
                                  >
                                </v-col>
                              </v-row>

                              <v-card
                                :style="{
                                  background:
                                    $vuetify.theme.themes[theme].background,
                                }"
                                v-if="importmenu2"
                                elevation="0"
                                width="190"
                                min-height="80"
                                class="ml-2 pr-1 mt-n3"
                              >
                                <div
                                  style="display: flex"
                                  class="ma-0 pa-0 ml-1 mt-n2"
                                >
                                  <div class="ma-0 pa-0">
                                    <p style="font-size: 11px" class="ml-3">
                                      Compression Level
                                    </p>
                                  </div>
                                  <v-spacer></v-spacer>
                                  <div class="ma-0 pa-0 mr-1">
                                    <p style="font-size: 11px" class="">
                                      <v-icon style="margin-top: -0.1em"
                                        >navigate_before</v-icon
                                      >8<v-icon style="margin-top: -0.1em"
                                        >navigate_next</v-icon
                                      >
                                    </p>
                                  </div>
                                </div>
                                <div
                                  class="ma-0 pa-0 ml-6 mt-n1"
                                  style="display: flex"
                                >
                                  <div class="ma-0 pa-0">
                                    <p style="font-size: 11px" class="ml-n2">
                                      Supercompression KTX v2
                                    </p>
                                  </div>
                                  <v-spacer></v-spacer>

                                  <div class="ma-0 pa-0">
                                    <v-checkbox
                                      class="ma-0 pa-0 mr-n1 mt-n1"
                                      v-model="supercompressionKTX"
                                    ></v-checkbox>
                                  </div>
                                </div>
                                <!-- <div style="display: flex">
                                  <p style="font-size: 11px" class="ml-4">
                                    No Draco
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                                </div>
                                <div style="display: flex" class="mt-n5">
                                  <p style="font-size: 11px" class="ml-4">
                                    UV's
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                                </div>

                                <div style="display: flex" class="mt-n5">
                                  <p style="font-size: 11px" class="ml-4">
                                    Vertex Colors
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                                </div>
                                <v-row class="mt-n8">
                                  <v-col cols="5">
                                    <p style="font-size: 11px" class="ml-4">
                                      Materials
                                    </p>
                                  </v-col>
                                  <v-col cols="4">
                                    <v-icon
                                      class="mt-n2"
                                      @click="
                                        materialtexture = !materialtexture
                                      "
                                      >mdi-menu-down</v-icon
                                    >
                                  </v-col>
                                  <v-col cols="1">
                                    <v-checkbox
                                      class="mt-n2 ml-n2"
                                    ></v-checkbox>
                                  </v-col>
                                  <v-col cols="1"> </v-col>
                                </v-row>
                                <div
                                  v-if="materialtexture"
                                  class="ma-0 pa-0 mt-n6 ml-4"
                                >
                                  <p
                                    style="font-size: 10px; font-weight: 450"
                                    class="ml-2"
                                  >
                                    Texture Format
                                  </p>
                                  <v-select
                                    rounded
                                    outlined
                                    dense
                                    label="Same as Sourse"
                                    class="mt-n3"
                                    :item="textureitem"
                                  >
                                  </v-select>
                                </div> -->
                              </v-card>
                            </v-card>
                            <v-divider
                              v-if="importmenu3"
                              vertical
                              style="border-color: #d3d3d3"
                              class="mt-3 mb-3"
                            ></v-divider>
                            <v-card
                              :style="{
                                background:
                                  $vuetify.theme.themes[theme].background,
                              }"
                              v-if="importmenu3"
                              elevation="0"
                              rounded="lg"
                              min-width="130"
                              min-height="110"
                              style="overflow: hidden"
                              class="pt-6 mt-1"
                            >
                              <div class="ma-0 mt-n1 pa-0 ml-3 mb-5">
                                <p
                                  style="font-weight: 600; font-size: 14px"
                                  class=""
                                >
                                  Detail Settings
                                </p>
                              </div>

                              <div
                                style="display: flex"
                                v-for="(item, index) in pickcompression"
                                :key="index"
                                class="ma-0 pa-0 mt-n4 ml-2"
                                @click="checkExportFiles(item, index)"
                              >
                                <div class="ma-0 pa-0">
                                  <md-icon
                                    v-if="augmentableTheme"
                                    class="md-size-x"
                                    style="cursor: pointer"
                                    :md-src="item.svg1"
                                  />
                                  <md-icon
                                    v-if="!augmentableTheme"
                                    class="md-size-x"
                                    style="cursor: pointer"
                                    :md-src="item.svg2"
                                  />
                                </div>
                                <div class="ma-0 pa-0">
                                  <p
                                    class="mt-1 ml-1"
                                    style="font-size: 14px; cursor: pointer"
                                  >
                                    {{ item.name }}
                                  </p>
                                </div>
                                <v-spacer></v-spacer>
                                <div class="ma-0 pa-0">
                                  <v-checkbox class="mt-n1 mr-2"></v-checkbox>
                                </div>
                              </div>

                              <div
                                style="display: flex"
                                class="ma-0 pa-0 mb-n1 ml-3"
                              >
                                <div class="ma-0 pa-0">
                                  <p
                                    style="font-weight: 600; font-size: 14px"
                                    class=""
                                  >
                                    Bake Settings
                                  </p>
                                </div>
                              </div>
                              <div
                                v-for="(item, index) in bakeTextureMaps"
                                :key="index"
                                style="display: flex"
                                class="ma-0 pa-0 mb-n4"
                              >
                                <div class="ma-0 pa-0 ml-3">
                                  <p style="font-size: 14px">
                                    {{ item.title }}
                                  </p>
                                </div>
                                <v-spacer></v-spacer>
                                <div class="ma-0 pa-0 mr-2">
                                  <v-checkbox
                                    v-model="item.checked"
                                    class="mt-n2"
                                  ></v-checkbox>
                                </div>
                              </div>

                              <div
                                style="display: flex"
                                class="ma-0 pa-0 mt-3 ml-4"
                              >
                                <div class="ma-0 pa-0">
                                  <md-icon
                                    v-if="augmentableTheme"
                                    class="md-size-x ml-n2 mt-n1"
                                    md-src="/static/assets/svg/white/dracoIcon.svg"
                                  />
                                  <md-icon
                                    v-if="!augmentableTheme"
                                    class="md-size-x ml-n2 mt-n1"
                                    md-src="/static/assets/svg/black/dracoIcon.svg"
                                  />
                                </div>
                                <div class="ma-0 pa-0 ml-2">
                                  <p
                                    style="font-weight: 600; font-size: 14px"
                                    class=""
                                  >
                                    Draco Settings
                                  </p>
                                </div>
                              </div>
                              <div
                                style="display: flex"
                                class="ma-0 pa-0 mt-1 mb-n4"
                              >
                                <div class="ma-0 pa-0 ml-3">
                                  <p style="font-size: 14px">Vertex Colors</p>
                                </div>
                                <v-spacer></v-spacer>
                                <div class="ma-0 pa-0 mr-2">
                                  <v-checkbox class="mt-n2"></v-checkbox>
                                </div>
                              </div>

                              <div
                                style="display: flex"
                                class="mt-n1"
                                v-for="(item, index) in dracoSettingsParameters"
                                :key="index"
                              >
                                <p style="font-size: 14px" class="ml-3">
                                  {{ item.title }}
                                </p>
                                <v-spacer></v-spacer>
                                <p style="font-size: 14px" class="mr-3">
                                  <v-icon
                                    style="margin-top: -0.1em"
                                    @click="mindracoquality(item)"
                                    >navigate_before</v-icon
                                  >{{ item.value
                                  }}<v-icon
                                    style="margin-top: -0.1em"
                                    @click="maxdracoquality(item)"
                                    >navigate_next</v-icon
                                  >
                                </p>
                              </div>
                            </v-card>
                          </div>
                          <!-- <div class="ma-0 pa-0" style="display: flex">
                            <v-card
                              elevation="0"
                              color="transparent"
                              class="ma-0 pa-0"
                              min-width="220"
                              min-height="80"
                              max-height="500"
                            >
                              <v-row class="pt-2">
                                <v-col cols="1"></v-col>
                                <v-col cols="6">
                                  <p style="font-size: 10px; font-weight: 600">
                                    Set Compression
                                  </p>
                                </v-col>
                                <v-col
                                  cols="1"
                                  style="cursor: pointer"
                                  @click="importmenu1 = !importmenu1"
                                >
                                  <v-icon
                                    class="ml-n4 mt-n2"
                                    v-if="!importmenu1"
                                  >
                                    mdi-menu-right
                                  </v-icon>
                                  <v-icon
                                    class="ml-n4 mt-n2"
                                    v-if="importmenu1"
                                  >
                                    mdi-menu-down
                                  </v-icon>
                                </v-col>
                                <v-col cols="1">
                                  <v-icon class="mt-n1 ml-n1"
                                    >settings_input_component</v-icon
                                  >
                                </v-col>
                                <v-col cols="1"></v-col>
                              </v-row>
                              <v-card
                                :style="{
                                  background:
                                    $vuetify.theme.themes[theme].background,
                                }"
                                v-if="importmenu1"
                                elevation="0"
                                width="180"
                                height="85"
                                class="ml-2 mr-1 mt-n4"
                              >
                                <v-row
                                  class="pa-0 ma-0 ml-3 mb-n11"
                                  v-for="(item, index) in quality"
                                  :key="index"
                                >
                                  <v-row class="pa-0 ma-0">
                                    <v-col cols="5">
                                      <p style="font-size: 11px" class="ml-n2">
                                        {{ item.title }}
                                      </p>
                                    </v-col>
                                    <v-col cols="6">
                                      <p style="font-size: 11px">
                                        <v-icon
                                          style="margin-top: -0.1em"
                                          @click="minquality(item)"
                                          >navigate_before</v-icon
                                        >{{ item.value
                                        }}<v-icon
                                          style="margin-top: -0.1em"
                                          @click="maxquality(item)"
                                          >navigate_next</v-icon
                                        >
                                      </p>
                                    </v-col>
                                    <v-col cols="1" class="mt-n6 ml-n4">
                                      <v-checkbox
                                        class="ml-n3"
                                        v-model="item.checked"
                                        @click="checkQualityValues(item)"
                                      ></v-checkbox>
                                    </v-col>
                                  </v-row>
                                </v-row>
                              </v-card>
                              <v-row class="mt-n4">
                                <v-col cols="7">
                                  <p
                                    class="ml-6"
                                    style="font-size: 10px; font-weight: 600"
                                  >
                                    Pick Compression
                                  </p>
                                </v-col>
                                <v-col
                                  cols="1"
                                  style="cursor: pointer"
                                  @click="importmenu2 = !importmenu2"
                                >
                                  <v-icon
                                    class="ml-n6 mt-n2"
                                    v-if="!importmenu2"
                                  >
                                    mdi-menu-right
                                  </v-icon>
                                  <v-icon
                                    class="ml-n6 mt-n2"
                                    v-if="importmenu2"
                                  >
                                    mdi-menu-down
                                  </v-icon>
                                </v-col>
                                <v-col cols="1">
                                  <md-icon
                                    v-if="augmentableTheme"
                                    class="md-size-x ml-n7 mt-n1"
                                    md-src="/static/assets/svg/white/dracoIcon.svg"
                                  />
                                  <md-icon
                                    v-if="!augmentableTheme"
                                    class="md-size-x ml-n7 mt-n1"
                                    md-src="/static/assets/svg/black/dracoIcon.svg"
                                  />
                                </v-col>
                                <v-col
                                  cols="1"
                                  class="mr-2"
                                  style="cursor: pointer"
                                >
                                  <v-icon
                                    class="mt-n2 ml-n5"
                                    @click="importmenu3 = !importmenu3"
                                  >
                                    mdi-menu-right</v-icon
                                  >
                                </v-col>
                              </v-row>

                              <v-card
                                :style="{
                                  background:
                                    $vuetify.theme.themes[theme].background,
                                }"
                                v-if="importmenu2"
                                elevation="0"
                                width="190"
                                min-height="150"
                                class="ml-2 pr-1 mt-n3"
                              >
                                <div style="display: flex">
                                  <p style="font-size: 11px" class="ml-4">
                                    UV's
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                                </div>

                                <div style="display: flex" class="mt-n5">
                                  <p style="font-size: 11px" class="ml-4">
                                    Vertex Colors
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                                </div>

                                <div style="display: flex" class="mt-n5">
                                  <p style="font-size: 11px" class="ml-4">
                                    Materials
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                                </div>

                                <div style="display: flex" class="mt-n5">
                                  <p style="font-size: 11px" class="ml-4">
                                    Compression Level
                                  </p>
                                  <v-spacer></v-spacer>
                                  <p style="font-size: 11px" class="mt-n1">
                                    <v-icon style="margin-top: -0.1em"
                                      >navigate_before</v-icon
                                    >8<v-icon style="margin-top: -0.1em"
                                      >navigate_next</v-icon
                                    >
                                  </p>
                                </div>

                                <div style="display: flex" class="mt-n1">
                                  <p style="font-size: 11px" class="ml-4">
                                    Quantize position
                                  </p>
                                  <v-spacer></v-spacer>
                                  <p style="font-size: 11px" class="mt-n1">
                                    <v-icon style="margin-top: -0.1em"
                                      >navigate_before</v-icon
                                    >8<v-icon style="margin-top: -0.1em"
                                      >navigate_next</v-icon
                                    >
                                  </p>
                                </div>

                                <div style="display: flex" class="mt-n1">
                                  <p style="font-size: 11px" class="ml-4">
                                    Normals
                                  </p>
                                  <v-spacer></v-spacer>
                                  <p style="font-size: 11px" class="mt-n1">
                                    <v-icon style="margin-top: -0.1em"
                                      >navigate_before</v-icon
                                    >8<v-icon style="margin-top: -0.1em"
                                      >navigate_next</v-icon
                                    >
                                  </p>
                                </div>

                                <div style="display: flex" class="mt-n1">
                                  <p style="font-size: 11px" class="ml-4">
                                    Tex Coord
                                  </p>
                                  <v-spacer></v-spacer>
                                  <p style="font-size: 11px" class="mt-n1">
                                    <v-icon style="margin-top: -0.1em"
                                      >navigate_before</v-icon
                                    >8<v-icon style="margin-top: -0.1em"
                                      >navigate_next</v-icon
                                    >
                                  </p>
                                </div>

                                <div style="display: flex" class="mt-n1">
                                  <p style="font-size: 11px" class="ml-4">
                                    Generic
                                  </p>
                                  <v-spacer></v-spacer>
                                  <p style="font-size: 11px" class="mt-n1">
                                    <v-icon style="margin-top: -0.1em"
                                      >navigate_before</v-icon
                                    >8<v-icon style="margin-top: -0.1em"
                                      >navigate_next</v-icon
                                    >
                                  </p>
                                </div>
                              </v-card>
                            </v-card>
                            <v-divider
                              v-if="importmenu3"
                              vertical
                              style="border-color: #d3d3d3"
                              class="mt-3 mb-3"
                            ></v-divider>
                            <v-card
                              :style="{
                                background:
                                  $vuetify.theme.themes[theme].background,
                              }"
                              v-if="importmenu3"
                              elevation="0"
                              rounded="lg"
                              width="130"
                              min-height="110"
                              style="overflow: hidden"
                              class="mt-15 mb-7"
                            >
                              <v-row class="mt-7 ml-2 mb-n1">
                                <h5
                                  style="
                                    color: blue;
                                    text-align: center;
                                    font-weight: 600;
                                  "
                                >
                                  Select
                                </h5>
                              </v-row>
                              <div
                                class="ml-2 mt-2 mb-3"
                                v-for="(item, index) in pickcompression"
                                :key="index"
                              >
                                <div style="display: flex" class="mb-n7">
                                  <p style="font-size: 10px; font-weight: 670">
                                    {{ item.title }}
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-checkbox class="mt-n2"></v-checkbox>
                                </div>
                              </div>
                            </v-card>
                          </div> -->
                          <!-- <v-row class="pt-2">
                            <v-col cols="1"></v-col>
                            <v-col cols="6">
                              <p style="font-size: 10px; font-weight: 600">
                                Set Compression
                              </p>
                            </v-col>
                            <v-col
                              cols="1"
                              style="cursor: pointer"
                              @click="importmenu1 = !importmenu1"
                            >
                              <v-icon class="ml-n4 mt-n2" v-if="!importmenu1">
                                mdi-menu-right
                              </v-icon>
                              <v-icon class="ml-n4 mt-n2" v-if="importmenu1">
                                mdi-menu-down
                              </v-icon>
                            </v-col>
                            <v-col cols="1">
                              <v-icon class="mt-n1 ml-n1"
                                >settings_input_component</v-icon
                              >
                            </v-col>
                            <v-col cols="1"></v-col>
                          </v-row>
                          <v-card
                            :style="{
                              background:
                                $vuetify.theme.themes[theme].background,
                            }"
                            v-if="importmenu1"
                            elevation="0"
                            width="180"
                            height="85"
                            class="ml-2 mr-1 mt-n4"
                          >
                            <v-row
                              class="pa-0 ma-0 ml-3 mb-n11"
                              v-for="(item, index) in quality"
                              :key="index"
                            >
                              <v-row class="pa-0 ma-0">
                                <v-col cols="5">
                                  <p style="font-size: 11px" class="ml-n2">
                                    {{ item.title }}
                                  </p>
                                </v-col>
                                <v-col cols="6">
                                  <p style="font-size: 11px">
                                    <v-icon
                                      style="margin-top: -0.1em"
                                      @click="minquality(item)"
                                      >navigate_before</v-icon
                                    >{{ item.value
                                    }}<v-icon
                                      style="margin-top: -0.1em"
                                      @click="maxquality(item)"
                                      >navigate_next</v-icon
                                    >
                                  </p>
                                </v-col>
                                <v-col cols="1" class="mt-n6 ml-n4">
                                  <v-checkbox
                                    class="ml-n3"
                                    v-model="item.checked"
                                    @click="checkQualityValues(item)"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-row>
                          </v-card>
                          <v-row class="mt-n4">
                            <v-col cols="7">
                              <p
                                class="ml-6"
                                style="font-size: 10px; font-weight: 600"
                              >
                                Pick Compression
                              </p>
                            </v-col>
                            <v-col
                              cols="1"
                              style="cursor: pointer"
                              @click="importmenu2 = !importmenu2"
                            >
                              <v-icon class="ml-n6 mt-n2" v-if="!importmenu2">
                                mdi-menu-right
                              </v-icon>
                              <v-icon class="ml-n6 mt-n2" v-if="importmenu2">
                                mdi-menu-down
                              </v-icon>
                            </v-col>
                            <v-col cols="1">
                              <md-icon
                                v-if="augmentableTheme"
                                class="md-size-x ml-n7 mt-n1"
                                md-src="/static/assets/svg/white/dracoIcon.svg"
                              />
                              <md-icon
                                v-if="!augmentableTheme"
                                class="md-size-x ml-n7 mt-n1"
                                md-src="/static/assets/svg/black/dracoIcon.svg"
                              />
                            </v-col>
                            <v-col
                              cols="1"
                              class="mr-2"
                              style="cursor: pointer"
                            >
                              <v-menu
                                rounded="lg"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                top
                                max-width="130"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-icon class="mt-n2 ml-n5" v-on="on">
                                    mdi-menu-right</v-icon
                                  >
                                </template>
                                <v-card
                                  :style="{
                                    background:
                                      $vuetify.theme.themes[theme].background,
                                  }"
                                  elevation="0"
                                  rounded="lg"
                                  width="130"
                                  height="76"
                                  style="overflow: hidden"
                                  class="ma-0 pa-0"
                                >
                                  <div
                                    class="ml-2 mt-2"
                                    v-for="(item, index) in pickcompression"
                                    :key="index"
                                  >
                                    <div style="display: flex" class="mb-n7">
                                      <p
                                        style="
                                          font-size: 10px;
                                          font-weight: 670;
                                        "
                                      >
                                        {{ item.title }}
                                      </p>
                                      <v-spacer></v-spacer>
                                      <v-checkbox class="mt-n2"></v-checkbox>
                                    </div>
                                  </div>
                                </v-card>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <v-card
                            :style="{
                              background:
                                $vuetify.theme.themes[theme].background,
                            }"
                            v-if="importmenu2"
                            elevation="0"
                            width="190"
                            min-height="150"
                            class="ml-2 pr-1 mt-n3"
                          >
                            <div style="display: flex">
                              <p style="font-size: 11px" class="ml-4">UV's</p>
                              <v-spacer></v-spacer>
                              <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                            </div>

                            <div style="display: flex" class="mt-n5">
                              <p style="font-size: 11px" class="ml-4">
                                Vertex Colors
                              </p>
                              <v-spacer></v-spacer>
                              <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                            </div>

                            <div style="display: flex" class="mt-n5">
                              <p style="font-size: 11px" class="ml-4">
                                Materials
                              </p>
                              <v-spacer></v-spacer>
                              <v-checkbox class="mt-n2 mr-1"></v-checkbox>
                            </div>

                            <div style="display: flex" class="mt-n5">
                              <p style="font-size: 11px" class="ml-4">
                                Compression Level
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Quantize position
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Normals
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Tex Coord
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>

                            <div style="display: flex" class="mt-n1">
                              <p style="font-size: 11px" class="ml-4">
                                Generic
                              </p>
                              <v-spacer></v-spacer>
                              <p style="font-size: 11px" class="mt-n1">
                                <v-icon style="margin-top: -0.1em"
                                  >navigate_before</v-icon
                                >8<v-icon style="margin-top: -0.1em"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </div>
                          </v-card> -->
                        </v-card>
                      </v-menu>
                    </v-col>
                    <v-col cols="2" class="ml-n4">
                      <p
                        class="caption-11"
                        style="font-weight: 700; opacity: 0.8"
                        v-if="item.value == 'draco'"
                      >
                        {{ compressionSetting.title }}
                      </p>
                    </v-col>
                    <v-col cols="1" class="ml-6">
                      <div style="display: flex">
                        <md-icon
                          v-if="augmentableTheme && item.value == 'draco'"
                          class="md-size-x ml-n7"
                          md-src="/static/assets/svg/white/dracoIcon.svg"
                        />
                        <md-icon
                          v-if="!augmentableTheme && item.value == 'draco'"
                          class="md-size-x ml-n7"
                          md-src="/static/assets/svg/black/dracoIcon.svg"
                        />
                        <v-icon class="ml-3" v-if="item.value == 'draco'"
                          >settings_input_component</v-icon
                        >
                      </div>
                    </v-col>
                    <v-col cols="4" class="ml-2 mr-n9">
                      <p
                        class="caption-11 mt-1 ml-15"
                        style="font-weight: 700; opacity: 0.8"
                      >
                        {{ item.size }}
                      </p>
                      <p
                        class="caption-11 mt-n2"
                        style="font-weight: 700; opacity: 0.8"
                        v-if="!item.size"
                      >
                        {{ item.titledetail }}
                      </p>
                    </v-col>
                  </v-row>
                </div>
              </v-card>

              <!-- <v-radio-group v-model="importType">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-radio
                      v-for="(item, index) in importFileItems"
                      v-on="on"
                      :key="index"
                      :color="item.color"
                      :label="item.title"
                      :value="item.value"
                    >
                      <template v-slot:label>
                        <div class="row">
                          <div class="col-4">{{ item.title }}</div>
                          <div class="col-4">{{ item.size }}</div>
                        </div>
                      </template>
                    </v-radio>
                  </template>
                  <span>you can select only one option.</span>
                </v-tooltip>
              </v-radio-group> -->

              <div
                class="pa-0"
                :style="{
                  background: $vuetify.theme.themes[theme].background,
                }"
              >
                <v-row justify="center">
                  <v-btn
                    v-if="augmentableTheme"
                    @click="addFileToServer"
                    icon
                    x-large
                  >
                    <md-icon
                      class="md-size-2x"
                      md-src="/static/assets/svg/white/Upload.svg"
                    ></md-icon>
                  </v-btn>
                  <v-btn
                    v-if="!augmentableTheme"
                    @click="addFileToServer"
                    icon
                    x-large
                  >
                    <md-icon
                      class="md-size-2x"
                      md-src="/static/assets/svg/black/Upload.svg"
                    ></md-icon>
                  </v-btn>
                </v-row>
              </div>

              <!-- <v-list
                class="pa-0"
                :style="{
                  background: $vuetify.theme.themes[theme].background,
                }"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-btn
                      v-if="augmentableTheme"
                      @click="addFileToServer"
                      icon
                    >
                      <md-icon
                        class="md-size-2x"
                        md-src="/static/assets/svg/white/Upload.svg"
                      ></md-icon>
                    </v-btn>
                    
                    <v-btn
                      v-if="!augmentableTheme"
                      @click="addFileToServer"
                      icon
                      
                    >
                      <md-icon
                        class="md-size-2x"
                        md-src="/static/assets/svg/black/Upload.svg"
                      ></md-icon>
                    </v-btn>
                    
                  </v-list-item-content>
                </v-list-item>
              </v-list> -->
              <!--<ordered-table></ordered-table>-->
            </md-card>
          </div>
        </div>
      </div>
    </div>
    <v-overlay :value="overlayP">
      <v-progress-circular v-bind="spinnerProps"
        ><div>{{ uploadPercentage }}</div></v-progress-circular
      >
    </v-overlay>
    <v-overlay :value="overlayP1">
      <v-progress-circular v-bind="spinnerProps"
        ><div>Draco</div></v-progress-circular
      >
    </v-overlay>
    <v-overlay :value="overlayP2">
      <v-progress-circular v-bind="spinnerProps"
        ><div>Uploading</div></v-progress-circular
      >
    </v-overlay>
    <v-overlay :value="overlayP4">
      <v-progress-circular v-bind="spinnerProps"
        ><div>Glb Preview</div></v-progress-circular
      >
    </v-overlay>
    <v-overlay v-if="overlayP5">
      <v-progress-circular v-bind="spinnerProps"
        ><div>Glb Preview</div></v-progress-circular
      >
    </v-overlay>
    <v-overlay v-if="mtlFileValue">
      <v-card width="300">
        <v-card-title>
          <span class="headline">Texture Metadata</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  cols="12"
                  accept=".mtl"
                  v-model="mtlFile"
                  placeholder="Pick mtl File"
                  label="MTL"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn> -->
          <v-btn color="blue darken-1" text @click="submitMtlFile()">
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
//import EditProfileForm from "./UserProfile/EditProfileForm";
//import UserCard from "./UserProfile/UserCard";

//import vue2Dropzone from "vue2-dropzone";
//import "vue2-dropzone/dist/vue2Dropzone.min.css";

//import "../assets/scss/material-dashboard.scss";
import manageTag from "../components/manageTag";
import { ModelViewerElement } from "@google/model-viewer/dist/model-viewer.js";

//import gltfPipeline from "gltf-pipeline";
//import fsExtra from "fs-extra";

import { showAt, hideAt } from "vue-breakpoints";

import store from "../store";
import { mapState } from "vuex";

import axios from "axios";
import AugmentableViewer from "../views/augmentableViewer.vue";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter.js";

export default {
  components: {
    manageTag,
    //EditProfileForm,
    //UserCard,
    hideAt,
    showAt,
    AugmentableViewer,
    //vueDropzone: vue2Dropzone,
  },

  props: {
    file1: Object,
    //compoID: String,
    compoID: {
      type: String,
      default: "1",
    },
    batch: {
      type: Boolean,
      default: false,
    },
    batchFile: Object,
    editorR: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      base64: "",

      Compressionquality: "0.0",
      computedCompressionquality: "0.0",
      Downsizingamount: "0.0",
      computedDownsizingamount: "0.0",
      photomaterialtexture: false,
      materialtexture: false,
      fileGlb: "",
      fbxFile: "",
      objFile: "",
      mtlFile: "",
      bmpFile: "",
      description: false,
      progress: false,
      status: false,
      tagsonoff: false,
      versions: false,
      colors: false,
      user: false,
      searchTag: "",
      tagmenu: false,
      importmenu1: true,
      importmenu2: false,
      importmenu3: false,
      importmenutexture: false,
      selectedImageFormat: ".png",
      selectedImageFormats: [
        {
          icon: "mdi-png",
          text: "PNG",
          value: ".png",
        },
        {
          icon: "mdi-jpg",
          text: "JPG",
          value: ".jpg",
        },
      ],
      selectedImageResolution: "4096px",
      selectedImageResolutions: [
        {
          icon: "mdi-png",
          text: "8192px",
          value: "8192px",
        },
        {
          icon: "mdi-png",
          text: "4096px",
          value: "4096px",
        },
        {
          icon: "mdi-jpg",
          text: "2048px",
          value: "2048px",
        },
        {
          icon: "mdi-png",
          text: "1024px",
          value: "1024px",
        },
        {
          icon: "mdi-jpg",
          text: "512px",
          value: "512px",
        },
      ],
      bakeTexture: false,
      bakeTextureMaps: [
        { title: "Diffuse Map", checked: false },
        { title: "Normal Map", checked: false },
      ],
      supercompressionKTX: false,
      lightTheme: false,
      darkTheme: false,
      textureitem: ["Same as Sourse", "JPEG"],
      items: ["Foo", "Bar", "Fizz", "Buzz"],
      pickcompression: [
        {
          name: "No Draco (huge files)",
          checked: false,
          svg1: "/static/assets/svg/white/draco.svg",
          svg2: "/static/assets/svg/black/dracoIcon.svg",
        },
        {
          name: "USD (.usd)",
          checked: false,
          svg1: "/static/assets/svg/white/usd.svg",
          svg2: "/static/assets/svg/black/USDIcon.svg",
        },
        {
          name: "USDZ (.usdz)",
          checked: false,
          svg1: "/static/assets/svg/white/usdz.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
        {
          name: "GLTF (.gltf)",
          checked: false,
          svg1: "/static/assets/svg/white/gltf.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
        {
          name: "GLB (.glb)",
          checked: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
      ],
      quality: [
        { title: "low", minValue: 0, maxValue: 9, value: 2, checked: false },
        { title: "medium", minValue: 0, maxValue: 9, value: 2, checked: false },
        { title: "high", minValue: 0, maxValue: 9, value: 8, checked: true },
      ],

      dracoSettingsParameters: [
        {
          title: "Quantize Position",
          minValue: 0,
          maxValue: 9,
          value: 4,
          checked: false,
        },
        {
          title: "Normals",
          minValue: 0,
          maxValue: 10,
          value: 6,
          checked: false,
        },
        {
          title: "Tex Coord",
          minValue: 0,
          maxValue: 10,
          value: 8,
          checked: true,
        },
        {
          title: "Generic",
          minValue: 0,
          maxValue: 10,
          value: 8,
          checked: true,
        },
      ],

      compressionSetting: {
        title: "high",
        value: 10,
      },
      localStatus: [
        { title: "unProcessed", value: true },
        { title: "inProgress", value: false },
        { title: "completed", value: false },
      ],
      selectedStatus: { title: "unProcessed", value: true },
      localitem: [
        {
          avatarcolor: "red",
          filepng: "/static/assets/images/screenshot.png",
          picheading: "V01",
          date: "30.12.2020",
          statusbanner: true,
          statusicon: true,
          statussmallicon: false,
          statusheadingcheck: true,
          statusheading: "unprocessed",
          progressbanner: true,
          progressicon: true,
          progressheadingcheck: true,
          progressheading: "texture optimized",
          datecheck: true,
        },
        {
          avatarcolor: "grey",
          filepng: "/static/assets/images/screenshot(1).png",
          picheading: "V02",
          date: "30.12.2020",
          statusbanner: true,
          statusicon: true,
          statussmallicon: true,
          statusheadingcheck: true,
          statusheading: "in complete",
          progressbanner: true,
          progressicon: true,
          progressheadingcheck: true,
          progressheading: "color change",
          datecheck: true,
        },
        {
          avatarcolor: "orange",
          filepng: "/static/assets/images/screenshot(2).png",
          picheading: "V03",
          date: "30.12.2020",
          statusbanner: false,
          statusicon: true,
          statussmallicon: false,
          statusheadingcheck: true,
          statusheading: "completed",
          progressbanner: true,
          progressicon: true,
          progressheadingcheck: true,
          progressheading: "material change",
          datecheck: true,
        },
        {
          avatarcolor: "purple",
          filepng: "/static/assets/images/screenshot.png",
          picheading: "V01",
          date: "30.12.2020",
          statusbanner: false,
          statusicon: false,
          statussmallicon: false,
          statusheadingcheck: false,
          progressbanner: true,
          progressicon: true,
          progressheadingcheck: true,
          progressheading: "texture optimized",
          datecheck: true,
        },
        {
          avatarcolor: "#00bfff",
          filepng: "/static/assets/images/screenshot(1).png",
          picheading: "V02",
          date: "30.12.2020",
          statusbanner: false,
          statusicon: false,
          statussmallicon: false,
          statusheadingcheck: false,
          progressbanner: false,
          progressicon: false,
          progressheadingcheck: false,
          datecheck: false,
        },
      ],
      dropOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        //maxFilesize: 0.5,
        maxFiles: 1,
      },
      importFileItems: [
        {
          title: "Original File",
          value: "original",
          color: "success",
          size: "",
          titledetail: "same file size",
          checked: true,
        },
        {
          title: "Optimized File",
          value: "draco",
          color: "orange",
          size: "",
          titledetail: "file size is optimized",
          checked: false,
        },
      ],
      importType: "original",
      fileSize: "",

      fullscreen: false,

      file2: {
        filename: "shamsail",
        type: "Glb",
        state: "Live",
        tags: "priority",
      },

      accountName: "",
      accountEmail: "",
      accountPassword: "",
      accountPasswordConfirm: "",

      error: false,
      errorMsg: "",

      rules: {
        required: (value) => !!value || "Required.",
        minPass: (v) => v.length >= 8 || "Min 8 characters",
        maxPass: (v) => v.length <= 30 || "Max 30 characters",
        minName: (v) => v.length >= 3 || "Min 3 characters",
        maxName: (v) => v.length <= 30 || "Max 30 characters",
        emailMatch: () => "The email and password you entered don't match",
        email: (value) => {
          if (value.length > 0) {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          }
        },
      },

      state: ["inProgress", "onHold", "inQueue", "complete"],
      tags: ["priority", "share", "fix", "urgent"],
      loading: false,
      search: "",

      selected: "inProgress",
      selectedTag: "share",

      fileUploadName: "",

      imageBlob: "",
      file: "",
      fileGLTF: "",
      extention: "",
      fileName: "",
      filedescription: "",
      selectedTags: [],

      serverTags: "",

      overlayP: false,
      overlayP1: false,
      overlayP2: false,
      overlayP4: false,
      overlayP5: false,

      spinnerProps: {
        color: "primary",
        value: 100,
        indeterminate: true,
        size: 80,
      },

      fileee: "",
      filee: "",

      fileblob: "",

      //obj and fbx
      mtlFileValue: false,
      //mtlFile: "",
      //obj and fbx
      localTags: [],
      fileNameChecked: false,

      //hdr Settings
      //start viewer settings data
      hdrSettings: false,
      glbRotation: false,
      glbAnimation: false,
      transparency: false,
      metalness: false,
      occlusion: false,
      lightbutton: true,
      mediabutton: false,
      circlebutton: false,
      spanbtncard: false,
      boxbtncard: false,
      colorbtncard: false,
      filebtncard: false,
      photobtncard: false,

      spanbtns: [
        { name: "Normals" },
        { name: "Albedo" },
        { name: "Reflectivity" },
        { name: "Gloss" },
        { name: "Typography" },
        { name: "Textured" },
      ],

      itemscolor: [
        { color: "yellow" },
        { color: "blue" },
        { color: "red" },
        { color: "pink" },
        { color: "orange" },
        { color: "grey" },
      ],

      filebtns: [
        {
          name: "Original File",
          checked: false,
        },
        {
          name: "GLB",
          checked: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },
        {
          name: "Draco GLB",
          checked: false,
          svg1: "/static/assets/svg/white/glb.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
        },
        {
          name: "Draco GLTF",
          checked: false,
          svg1: "/static/assets/svg/white/gltf.svg",
          svg2: "/static/assets/svg/black/GLBIcon.svg",
          // svg1: "/static/assets/svg/white/dracoIcon.svg",
          // svg2: "/static/assets/svg/black/dracoIcon.svg",
        },

        // {
        //   name: "Draco",
        //   checked: true,
        //   svg1: "/static/assets/svg/white/GLBIcon.svg",
        //   svg2: "/static/assets/svg/black/GLBIcon.svg",
        // },
        {
          name: "USD",
          checked: false,
          svg1: "/static/assets/svg/white/usd.svg",
          svg2: "/static/assets/svg/black/USDIcon.svg",
        },
        {
          name: "USDZ",
          checked: false,
          svg1: "/static/assets/svg/white/usdz.svg",
          svg2: "/static/assets/svg/black/USDZIcon.svg",
        },
      ],
      hdrFile: "",
      hdrFileName: "",
      dialog: "",

      //end viewer settings data

      //viewer settings

      //rotation speed and direction
      speedAndDirectionOfModel: "20",
      skipWatchOfSD: false,
      directionClockWise: true,
      speedDirection: "",
      //rotation speed and direction

      //animation
      animationLoop: false,
      animationList: [],
      animationSelect: "",
      //animation

      //shadow settings
      shadowIntensity: "0.0",
      shadowSoftness: "0.0",
      computedShadowIntensity: "0.0",
      computedShadowSoftness: "0.0",
      //shadow settings

      //HDR settings
      hdrExposure: "1",
      asSkybox: false,
      neutralLight: true,
      //HDR setttings

      //viewer settings
      //hdr Settings

      document1: "",

      uploadPercentage: 0,
    };
  },

  computed: {
    ...mapState(["augmentableTheme"]),
    themeDark() {
      // is triggered whenever the store state changes
      //return this.somestate + " works too";
      return this.augmentableTheme;
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    localtags() {
      const search = this.searchTag.toLowerCase();

      if (!search) return store.state.tags;

      return store.state.tags.filter((item) => {
        const text = item.title.toLowerCase();

        return text.indexOf(search) > -1;
      });
    },

    computedCompoID() {
      return "loading-demo-sub" + this.compoID;
    },
  },

  watch: {
    augmentableTheme: function (val) {
      if (val === true) {
        this.lightTheme = false;
        this.darkTheme = true;
      } else {
        this.lightTheme = true;
        this.darkTheme = false;
      }
    },

    fileUploadName(val) {
      if (this.fileNameChecked) {
        this.fileName = val;
      }
    },

    fileNameChecked(val) {
      if (val === true) {
        this.fileName = this.fileUploadName;
      } else {
        this.fileName = "";
      }
    },

    //hdr settings
    directionClockWise: function (val) {
      if (val === true) {
        this.speedDirection = "";
        this.speedAndDirectionOfModel = (
          parseInt(this.speedAndDirectionOfModel) +
          1 -
          1
        ).toString();
      } else {
        this.speedDirection = "-";
        this.speedAndDirectionOfModel = (
          parseInt(this.speedAndDirectionOfModel) +
          1 -
          1
        ).toString();
      }
    },
    speedAndDirectionOfModel: function (val) {
      if (this.skipWatchOfSD === false) {
        this.skipWatchOfSD = true;
        return;
      }
      if (this.glbRotation === false) {
        this.glbRotation = true;
      }

      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo");
      if (viewer) {
        viewer["rotationPerSecond"] = this.speedDirection + val + "deg";
      }
    },
    glbRotation: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub" + this.compoID);
      if (viewer) {
        if (val === true) {
          viewer["autoRotateDelay"] = 200;
          viewer["autoRotate"] = true;
        } else {
          viewer["autoRotate"] = false;
        }
      }
    },

    glbAnimation: function (val) {
      let modelViewer = new ModelViewerElement();
      modelViewer = document.getElementById("loading-demo-sub" + this.compoID);

      if (modelViewer) {
        if (val === true) {
          modelViewer.play();

          if (this.animationLoop) {
            return;
          } else {
            var extremelySmallIntervalTime = 0.05;
            var j = 0;
            const interval = setInterval(function () {
              console.log(modelViewer.currentTime);
              if (
                modelViewer.currentTime > 0 &&
                modelViewer.currentTime < extremelySmallIntervalTime - 0.01
              ) {
                ++j;
                console.log(j);
                if (j > 0) {
                  modelViewer.pause();
                  j = 0;
                  clearInterval(interval);
                }
              } else if (modelViewer.currentTime == 0) {
                modelViewer.play();
              }
            }, extremelySmallIntervalTime * 1000);
          }
        } else {
          modelViewer.pause();
        }
      }
    },
    animationLoop: function (val) {
      if (val === true) {
        this.glbAnimation = true;
        console.log(this.glbAnimation);
      }
      // else {
      //   this.glbAnimation = !this.glbAnimation;
      //   this.glbAnimation = !this.glbAnimation;
      // }
    },

    asSkybox: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub" + this.compoID);
      if (viewer) {
        if (val === true) {
          viewer.setAttribute("skybox-image", this.hdrItem);
        } else {
          viewer.removeAttribute("skybox-image");
        }
      }
    },

    neutralLight: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub" + this.compoID);
      if (viewer) {
        if (val === true) {
          viewer.setAttribute("environment-image", "neutral");
        } else {
          viewer.setAttribute("environment-image", "");
        }
      }
    },

    hdrExposure: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub" + this.compoID);
      viewer["exposure"] = parseFloat(val);
    },
    shadowIntensity: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub" + this.compoID);
      viewer["shadowIntensity"] = parseFloat(val);
      this.computedShadowIntensity = val.toFixed(1);
    },
    shadowSoftness: function (val) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub" + this.compoID);
      viewer["shadowSoftness"] = parseFloat(val);
      this.computedShadowSoftness = val.toFixed(1);
    },
    //hdr settings
  },

  mounted() {
    console.log(this.compoID);
    console.log(this.editorR);
    var document1 = document.getElementById(this.compoID);
    console.log(document1);
    console.log(this.batch);
    console.log(this.batchFile);
    // document1.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
    //   const dropZoneElement = inputElement.closest(".drop-zone");
    //   //batch
    //   if (this.batch === true) {
    //     console.log(this.batchFile);
    //     this.updateThumbnail(dropZoneElement, this.batchFile);
    //   }
    //   //batch
    //   dropZoneElement.addEventListener("dragover", (e) => {
    //     e.preventDefault();
    //     //dropZoneElement.classList.add("drop-zone--over");
    //   });
    //   ["dragleave", "dragend"].forEach((type) => {
    //     dropZoneElement.addEventListener(type, (e) => {
    //       console.log(e);
    //       //dropZoneElement.classList.remove("drop-zone--over");
    //     });
    //   });

    //   dropZoneElement.addEventListener("drop", (e) => {
    //     e.preventDefault();
    //     if (e.dataTransfer.files.length) {
    //       inputElement.files = e.dataTransfer.files;
    //       this.updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
    //     }
    //   });
    // });

    this.themeDark = store.state.augmentableTheme;
    if (this.themeDark === false) {
      this.$vuetify.theme.dark = false;
    } else if (this.themeDark === true) {
      this.$vuetify.theme.dark = true;
    }
    if (this.augmentableTheme === true) {
      this.darkTheme = true;
    } else {
      this.lightTheme = true;
    }
  },

  methods: {
    selectviewerfile(x) {
      var i;
      var len;
      for (i = 0, len = this.filebtns.length; i < len; i++) {
        if (x === i) {
          this.filebtns[i].checked = true;
        } else {
          this.filebtns[i].checked = false;
        }
      }

      for (i = 2, len = this.downloadFileItems.length; i <= len; i++) {
        if (x + 1 === i) {
          this.downloadFileItems[i].list = true;
        } else {
          this.downloadFileItems[i].list = false;
        }
      }

      // // starting from 2 because 0,1 we have original and optimized
      // for (i=2,len=this.downloadFileItems.length;i<len;i++){
      //   if(this.downloadFileItems[i].value==="draco"){
      //     this.downloadFileItems[i].list = true;
      //   }
      //   else if(this.downloadFileItems[i].value==="glb"){
      //     this.downloadFileItems[i].list = true;
      //   }
      //   else if(this.downloadFileItems[i].value==="gltf"){

      //   }
      //   else if(this.downloadFileItems[i].value==="glb"){

      //   }
      //   else if(this.downloadFileItems[i].value==="usd"){

      //   }
      //   else if(this.downloadFileItems[i].value==="usdz"){

      //   }
      // }

      //this.downloadFileItems[index].list = this.filebtns[index].checked;
    },
    minquality(y) {
      if (y.value > 0) {
        y.value = y.value - 1;
        var index = this.quality.findIndex((x) => x.title === y.title);
        this.quality[index].value = y.value;
      }
    },
    maxquality(y) {
      if (y.value < 10) {
        y.value = y.value + 1;
        var index = this.quality.findIndex((x) => x.title === y.title);
        this.quality[index].value = y.value;
      }
    },
    mindracoquality(y) {
      if (y.value > 0) {
        y.value = y.value - 1;
        var index = this.dracoSettingsParameters.findIndex(
          (x) => x.title === y.title
        );
        this.dracoSettingsParameters[index].value = y.value;
      }
    },
    maxdracoquality(y) {
      if (y.value < 10) {
        y.value = y.value + 1;
        var index = this.dracoSettingsParameters.findIndex(
          (x) => x.title === y.title
        );
        this.dracoSettingsParameters[index].value = y.value;
      }
    },
    tagpass(x, y) {
      this.tagmenu = false;
      var obj = {
        title: "",
        color: "",
      };
      obj.title = x;
      obj.color = y;
      this.selectedTags.unshift(obj);
      x = "";
      y = "";

      this.serverTags = JSON.stringify(this.selectedTags);
      if (this.serverTags.length > 490) {
        this.selectedTags.shift();
        this.serverTags = JSON.stringify(this.selectedTags);
        alert("you can't add more tags to it");
      }
      //console.log(this.serverTags);
      //console.log(JSON.parse(this.serverTags));
    },
    updateThumbnail(dropZoneElement, file) {
      let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");
      console.log(file);

      //first time remove it
      if (dropZoneElement.querySelector(".drop-zone__prompt")) {
        dropZoneElement.querySelector(".drop-zone__prompt").remove();
      }

      //added o remove previous model element with all its hotspots
      var modelRemoveElement = document.getElementById(
        "loading-demo-sub" + this.compoID
      );
      if (file.name.split(".").pop() === "glb") {
        if (modelRemoveElement) {
          modelRemoveElement.remove();
          thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");
        }
      }

      //fist time there is no thumbnail then create
      if (!thumbnailElement) {
        thumbnailElement = document.createElement("model-viewer");

        thumbnailElement.classList.add("drop-zone__thumb");
        //thumbnailElement.setAttribute("auto-rotate", ""); //added functionality
        thumbnailElement.setAttribute("camera-controls", "");

        //needs to be added

        thumbnailElement.setAttribute("ar", "");
        thumbnailElement.setAttribute(
          "ar-modes",
          "webxr scene-viewer quick-look"
        );
        thumbnailElement.setAttribute("ar-scale", "auto");

        //thumbnailElement.setAttribute("autoplay", ""); //added functionality
        //thumbnailElement.setAttribute("animation-name", "Running");

        thumbnailElement.setAttribute("camera-orbit", "0deg 75deg 105%");

        thumbnailElement.setAttribute("environment-image", "neutral");
        this.neutralLight = true;

        //thumbnailElement.setAttribute("interaction-prompt-threshold", "0");
        //thumbnailElement.setAttribute("auto-rotate-delay", "0");
        //thumbnailElement.setAttribute("shadow-intensity", "1"); //added functionality
        thumbnailElement.setAttribute("id", "loading-demo-sub" + this.compoID);

        thumbnailElement.style.width = "100%";
        thumbnailElement.style.height = "50vh"; //100 --> 50 due to window size
        thumbnailElement.style.minHeight = "50vh";
        dropZoneElement.appendChild(thumbnailElement);
      }

      thumbnailElement.dataset.label = file.name;
      this.fileUploadName = file.name;

      this.fileUploadName = this.fileUploadName.replace(/\.[^/.]+$/, "");
      //console.log(this.fileName);
      //this.fileName = this.fileName.replace(/\.[^/.]+$/, "");
      //console.log(this.fileName);
      this.version = "VERSION 1.0";

      this.extention = file.name.split(".").pop();
      //console.log(this.extention);
      //console.log(file.name);

      if (this.extention === "glb" || this.extention === "gltf") {
        //thumbnailElement.src = "static/assets/images/" + file.name;

        //this is very very important for local system , also it will save space on server to load src without being file transfered to server and call it.
        thumbnailElement.src = URL.createObjectURL(file);

        thumbnailElement.addEventListener("load", () => {
          this.animationList = thumbnailElement.availableAnimations;
          this.animationSelect = this.animationList[0];

          URL.revokeObjectURL(thumbnailElement.src);
        });

        console.log("yes it is");

        thumbnailElement.addEventListener("camera-change", this.Listen);
      }

      //fileSize
      this.file = file;

      this.fileSize = this.file.size;
      this.fileSizeCalc();
      //fileSize

      //obj
      if (this.extention === "obj") {
        //this.obj2gltf();
        //this.mtlFileValue = true;
        this.objFile = file;
        this.obj2glb();
      }
      //obj

      //fbx
      // if (this.extention === "fbx") {
      //   this.fbxFile = file;
      //   this.fbx2glb();
      // }
      //fbx

      if (this.extention === "zip") {
        this.remeshObj();
      }
    },
    updateThumbnail2(dropZoneElement, file) {
      let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");
      console.log(file);

      //first time remove it
      if (dropZoneElement.querySelector(".drop-zone__prompt")) {
        dropZoneElement.querySelector(".drop-zone__prompt").remove();
      }

      //added o remove previous model element with all its hotspots
      var modelRemoveElement = document.getElementById(
        "loading-demo-sub" + this.compoID
      );
      if (this.objFile.name.split(".").pop() === "glb") {
        if (modelRemoveElement) {
          modelRemoveElement.remove();
          thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");
        }
      }

      //fist time there is no thumbnail then create
      if (!thumbnailElement) {
        thumbnailElement = document.createElement("model-viewer");

        thumbnailElement.classList.add("drop-zone__thumb");

        thumbnailElement.setAttribute("camera-controls", "");

        thumbnailElement.setAttribute("camera-orbit", "0deg 75deg 105%");

        thumbnailElement.setAttribute("id", "loading-demo-sub" + this.compoID);

        thumbnailElement.style.width = "100%";
        thumbnailElement.style.height = "50vh"; //100 --> 50 due to window size
        thumbnailElement.style.minHeight = "50vh";
        dropZoneElement.appendChild(thumbnailElement);
      }

      thumbnailElement.dataset.label = this.objFile.name;

      this.fileUploadName = this.objFile.name;

      this.fileUploadName = this.fileUploadName.replace(/\.[^/.]+$/, "");
      //console.log(this.fileName);
      //this.fileName = this.fileName.replace(/\.[^/.]+$/, "");
      //console.log(this.fileName);
      this.version = "VERSION 1.0";

      this.extention = this.objFile.name.split(".").pop();
      //console.log(this.extention);
      //console.log(file.name);

      //fileSize
      this.file = this.objFile;

      this.fileSize = this.file.size;
      var i;
      var len;

      for (i = 0, len = this.importFileItems.length; i < len; i++) {
        if (this.importFileItems[i].value === "original") {
          this.importFileItems[i].size =
            "" + (this.fileSize / (1024 * 1024)).toFixed(2) + "MB";
        } else if (this.importFileItems[i].value === "draco") {
          this.importFileItems[i].size =
            "" + (this.fileSize / (1024 * 1024)).toFixed(2) + "MB" + "/4*";
        }
      }
      //fileSize

      //obj

      this.obj2glbM();
    },
    updateThumbnail1(dropZoneElement, files) {
      console.log(dropZoneElement, files);
      // let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");
      // console.log(files);
      // //first time remove it
      // if (dropZoneElement.querySelector(".drop-zone__prompt")) {
      //   dropZoneElement.querySelector(".drop-zone__prompt").remove();
      // }
      // //fist time there is no thumbnail then create
      // if (!thumbnailElement) {
      //   thumbnailElement = document.createElement("model-viewer");
      //   thumbnailElement.classList.add("drop-zone__thumb");
      //   //thumbnailElement.setAttribute("auto-rotate", ""); //added functionality
      //   thumbnailElement.setAttribute("camera-controls", "");
      //   //needs to be added
      //
      //   thumbnailElement.setAttribute("ar", "");
      //   thumbnailElement.setAttribute(
      //     "ar-modes",
      //     "webxr scene-viewer quick-look"
      //   );
      //   thumbnailElement.setAttribute("ar-scale", "auto");
      //
      //   //thumbnailElement.setAttribute("autoplay", ""); //added functionality
      //   //thumbnailElement.setAttribute("animation-name", "Running");
      //   thumbnailElement.setAttribute("camera-orbit", "0deg 75deg 105%");
      //   //thumbnailElement.setAttribute("interaction-prompt-threshold", "0");
      //   //thumbnailElement.setAttribute("auto-rotate-delay", "0");
      //   //thumbnailElement.setAttribute("shadow-intensity", "1"); //added functionality
      //   thumbnailElement.setAttribute("id", "loading-demo-sub");
      //   thumbnailElement.style.width = "100%";
      //   thumbnailElement.style.height = "50vh"; //100 --> 50 due to window size
      //   thumbnailElement.style.minHeight = "50vh";
      //   dropZoneElement.appendChild(thumbnailElement);
      // }
      // // thumbnailElement.dataset.label = file.name;
      // // this.fileUploadName = file.name;
      // // this.extention = file.name.split(".").pop();
      // var mtlTTT = "";
      // if (files[0].name.split(".").pop() === "obj") {
      //   this.file = files[0];
      //   this.fileSize = this.file.size;
      //   thumbnailElement.dataset.label = this.file.name;
      //   this.fileUploadName = this.file.name;
      //   this.extention = this.file.name.split(".").pop();
      //   if (files[1].name.split(".").pop() === "mtl") {
      //     mtlTTT = files[1];
      //   }
      // } else {
      //   if (files[1].name.split(".").pop() === "mtl") {
      //     this.file = files[1];
      //     this.fileSize = this.file.size;
      //     thumbnailElement.dataset.label = this.file.name;
      //     this.fileUploadName = this.file.name;
      //     this.extention = this.file.name.split(".").pop();
      //     if (files[0].name.split(".").pop() === "obj") {
      //       mtlTTT = files[0];
      //     }
      //   }
      // }
      // //fileSize
      // // this.file = file;
      // // this.fileSize = this.file.size;
      // var i;
      // var len;
      // for (i = 0, len = this.importFileItems.length; i < len; i++) {
      //   if (this.importFileItems[i].value === "original") {
      //     this.importFileItems[i].size =
      //       "" + (this.fileSize / (1024 * 1024)).toFixed(2) + "MB";
      //   } else if (this.importFileItems[i].value === "draco") {
      //     this.importFileItems[i].size =
      //       "" + (this.fileSize / (1024 * 1024)).toFixed(2) + "MB" + "/4*";
      //   }
      // }
      // //fileSize
      // //obj
      // if (this.extention === "obj") {
      //   this.obj2gltfM();
      //   //this.mtlFileValue = true;
      // }
      // //obj
    },
    Listen() {
      console.log("hi listener");
      //const modelViewer = document.querySelector("model-viewer");
      const modelViewer = document.getElementById(
        "loading-demo-sub" + this.compoID
      );
      const orbit = modelViewer.getCameraOrbit();
      const fov = modelViewer.getFieldOfView();

      const orbitString = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius}m`;
      const fovString = `${fov}deg`;
      console.log(orbitString);
      console.log(fovString);

      modelViewer.removeEventListener("camera-change", this.Listen);

      modelViewer.addEventListener("camera-change", this.Listen1);
    },
    Listen1() {
      console.log("hi listener1");
      //const modelViewer = document.querySelector("model-viewer");
      const modelViewer = document.getElementById(
        "loading-demo-sub" + this.compoID
      );
      const orbit = modelViewer.getCameraOrbit();
      const fov = modelViewer.getFieldOfView();

      const orbitString = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius}m`;
      const fovString = `${fov}deg`;
      console.log(orbitString);
      console.log(fovString);

      modelViewer.removeEventListener("camera-change", this.Listen1);

      modelViewer.addEventListener("camera-change", this.Listen2);
    },
    Listen2() {
      console.log("hi listener2");
      //const modelViewer = document.querySelector("model-viewer");
      const modelViewer = document.getElementById(
        "loading-demo-sub" + this.compoID
      );
      const orbit = modelViewer.getCameraOrbit();
      const fov = modelViewer.getFieldOfView();

      const orbitString = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius}m`;
      const fovString = `${fov}deg`;
      console.log(orbitString);
      console.log(fovString);

      this.screenShotModel1().then((result) => console.log(result));

      modelViewer.removeEventListener("camera-change", this.Listen2);

      //modelViewer.addEventListener("camera-change", this.Listen2);
    },
    async screenShotModel1() {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub" + this.compoID);
      let posterUrl = "";
      //const a = document.createElement("a");
      const orbit = viewer.getCameraOrbit();

      viewer.fieldOfView = "auto";
      const fov = viewer.getFieldOfView();

      const orbitString = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius}m`;
      const fovString = `${fov}deg`;
      console.log(orbitString);
      console.log(fovString);

      //orbitString.textContent = `${orbit.theta}rad ${orbit.phi}rad auto`;
      console.log(orbit);
      viewer.fieldOfView = "auto";
      //viewer.jumpCameraToGoal();
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));
      URL.revokeObjectURL(posterUrl);
      const blob = await viewer.toBlob({
        mimeType: "image/png",
        idealAspect: true,
      });
      console.log(blob);

      //assign blob to variable
      this.imageBlob = blob;
    },

    async generateThumbnail() {
      await this.sleep(100);

      let { model } = this.$refs.model;

      let { droppedFiles } = this.$refs.model;
      Array.from(droppedFiles).forEach(([path, file]) => {
        console.log(path);
        console.log(file);
        //file.path = "sgghh/hhk";
        //console.log(file);
      });

      this.base64 = model.renderer.domElement.toDataURL("image/png", 1);
      //this.myTestFunc1(model.renderer.domElement);
      // var newDataUri = await this.resizedataURL(this.base64, 490, 490);
      // this.base64 = newDataUri;

      //this.cropImageFromCanvas(model.renderer.domElement.getContext("2d"));
      //var trimmedCanvas = this.trimCanvas(model.renderer.domElement);

      //var a = document.createElement("a"); //Create <a>
      // a.href = this.base64; //Image Base64 Goes here
      // a.download = "Image.png"; //File name Here
      // a.click(); //Downloaded file

      //let filepng = await fetch(this.base64).then((r) => r.blob());
      // a.href = URL.createObjectURL(filepng);
      // a.download = "screenshot.png";
      // a.click();

      //console.log("fdfdfdfdfdfdf");
      let { fileName } = this.$refs.model;
      let { fileType } = this.$refs.model;
      let { fileSize } = this.$refs.model;
      this.fileUploadName = fileName;
      this.extention = fileType;
      this.fileSize = fileSize;
      this.fileSizeCalc();
      //console.log(fileName);
      //console.log(fileType);
      //this.generateGLTF(model.scene, true);
    },
    cropImageFromCanvas(ctx) {
      var canvas = ctx.canvas,
        w = canvas.width,
        h = canvas.height,
        pix = { x: [], y: [] },
        imageData = ctx.getImageData(0, 0, canvas.width, canvas.height),
        x,
        y,
        index;

      for (y = 0; y < h; y++) {
        for (x = 0; x < w; x++) {
          index = (y * w + x) * 4;
          if (imageData.data[index + 3] > 0) {
            pix.x.push(x);
            pix.y.push(y);
          }
        }
      }
      pix.x.sort(function (a, b) {
        return a - b;
      });
      pix.y.sort(function (a, b) {
        return a - b;
      });
      var n = pix.x.length - 1;

      w = 1 + pix.x[n] - pix.x[0];
      h = 1 + pix.y[n] - pix.y[0];
      var cut = ctx.getImageData(pix.x[0], pix.y[0], w, h);

      canvas.width = w;
      canvas.height = h;
      ctx.putImageData(cut, 0, 0);

      var image = canvas.toDataURL(); //open cropped image in a new window
      var win = window.open(image, "_blank");
      win.focus();
    },
    trimCanvas(c) {
      var ctx = c.getContext("2d"),
        copy = document.createElement("canvas").getContext("2d"),
        pixels = ctx.getImageData(0, 0, c.width, c.height),
        l = pixels.data.length,
        i,
        bound = {
          top: null,
          left: null,
          right: null,
          bottom: null,
        },
        x,
        y;

      // Iterate over every pixel to find the highest
      // and where it ends on every axis ()
      for (i = 0; i < l; i += 4) {
        if (pixels.data[i + 3] !== 0) {
          x = (i / 4) % c.width;
          y = ~~(i / 4 / c.width);

          if (bound.top === null) {
            bound.top = y;
          }

          if (bound.left === null) {
            bound.left = x;
          } else if (x < bound.left) {
            bound.left = x;
          }

          if (bound.right === null) {
            bound.right = x;
          } else if (bound.right < x) {
            bound.right = x;
          }

          if (bound.bottom === null) {
            bound.bottom = y;
          } else if (bound.bottom < y) {
            bound.bottom = y;
          }
        }
      }

      // Calculate the height and width of the content
      var trimHeight = bound.bottom - bound.top,
        trimWidth = bound.right - bound.left,
        trimmed = ctx.getImageData(
          bound.left,
          bound.top,
          trimWidth,
          trimHeight
        );

      copy.canvas.width = trimWidth;
      copy.canvas.height = trimHeight;
      copy.putImageData(trimmed, 0, 0);

      // Return trimmed canvas
      return copy.canvas;
    },

    trim(c) {
      var ctx = c.getContext("2d"),
        copy = document.createElement("canvas").getContext("2d"),
        pixels = ctx.getImageData(0, 0, c.width, c.height),
        l = pixels.data.length,
        i,
        bound = {
          top: null,
          left: null,
          right: null,
          bottom: null,
        },
        x,
        y;

      for (i = 0; i < l; i += 4) {
        if (pixels.data[i + 3] !== 0) {
          x = (i / 4) % c.width;
          y = ~~(i / 4 / c.width);

          if (bound.top === null) {
            bound.top = y;
          }

          if (bound.left === null) {
            bound.left = x;
          } else if (x < bound.left) {
            bound.left = x;
          }

          if (bound.right === null) {
            bound.right = x;
          } else if (bound.right < x) {
            bound.right = x;
          }

          if (bound.bottom === null) {
            bound.bottom = y;
          } else if (bound.bottom < y) {
            bound.bottom = y;
          }
        }
      }

      var trimHeight = bound.bottom - bound.top,
        trimWidth = bound.right - bound.left,
        trimmed = ctx.getImageData(
          bound.left,
          bound.top,
          trimWidth,
          trimHeight
        );

      copy.canvas.width = trimWidth;
      copy.canvas.height = trimHeight;
      copy.putImageData(trimmed, 0, 0);

      // open new window with trimmed image:
      return copy.canvas;
    },

    inputFileClick() {
      console.log("gjhfgjhf");
      document.getElementById("rr1").click();
    },
    changeScene() {
      var inputElement = document.getElementById("rr1");
      console.log(inputElement);

      const dropZoneElement = inputElement.closest(".drop-zone");

      this.updateThumbnail(dropZoneElement, inputElement.files[0]);
    },

    compressFileToServer() {
      let formData = new FormData();
      formData.append("fileglb", this.file);

      axios
        .post("/node/api/compressFile/", formData, {
          ///node/api/compressFile/
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);
          //late added
          axios
            .get("/node/foo/file/" + response.data, {
              responseType: "arraybuffer",
              headers: {
                "Content-Type": "application/octet-stream",
                "Content-Disposition": "picture.glb",
                Accept: "application/glb",
              },
            })
            .then((response) => {
              //   let file = await fetch(this.selected1[i].versionsIDs[j].fileglb)
              // .then((r) => r.blob())
              // .then((blobFile) => new File([blobFile], "" + downloadName));

              //this.file = new Blob([response.data]);
              this.file = new File([response.data], this.file.name);

              this.fileSize = this.file.size;
              this.fileSizeCalc();

              const url = window.URL.createObjectURL(new Blob([response.data]));
              //model src
              let viewer = new ModelViewerElement();
              viewer = document.getElementById(
                "loading-demo-sub" + this.compoID
              );
              viewer.src = url;
              //model src
              /* 
            //working

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.glb'); //or any other extension
            document.body.appendChild(link);
            link.click();

            */

              this.overlayP1 = false;
            })
            .catch((error) => {
              console.log(error);
              //this.errored = true;

              this.overlayP1 = false;
            });
          //late added

          //viewer.src = "static/images/" + this.fileName;
          //this.$router.push({ path: "/assets" });

          //console.log(response);

          //var blob = new Blob([response.data], {
          //  type: response.headers.get("content-type"),
          //});
          // console.log(blob);
          //var link = document.createElement("a");
          //link.href = window.URL.createObjectURL(blob);
          //link.download = "ffiillee.glb";
          //link.click();

          //console.log(response.data);

          //this.fileee = response.data;

          //const glTF = await viewer.exportScene(options);
          /*
          var f = new File([this.fileee], "export.glb");
          //var file = new File([glTF], binary ? "export.glb" : "export.gltf");
          var link = document.createElement("a");
          link.download = f.name;
          link.href = URL.createObjectURL(f);
          link.click();
          */

          console.log("SUCCESS!!");
        })
        .catch((error) => {
          console.log(error.status);
          //console.log("ffff");
          //this.$router.push({ path: "/assets" });

          this.overlayP1 = false;
        });

      this.overlayP1 = true;
    },

    // obj2gltfM(mtl) {
    //   axios
    //     .post("/node/api/convertobjtogltf/", formData, {
    //       ///node/api/compressFile/
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //       },
    //     })
    //     .then((response) => {
    //       console.log(response.data);
    //       //late added
    //       axios
    //         .get("/node/foo/file/gltf/" + response.data, {
    //           responseType: "arraybuffer",
    //           headers: {
    //             "Content-Type": "application/octet-stream",
    //           },
    //         })
    //         .then((response) => {
    //           console.log("checkFile");
    //           console.log(response.data);
    //           this.fileGLTF = new Blob([response.data]);

    //           const url = window.URL.createObjectURL(new Blob([response.data]));

    //           // model src
    //           let viewer = new ModelViewerElement();
    //           viewer = document.getElementById("loading-demo-sub");
    //           viewer.src = url;
    //           // model src

    //           // //working

    //           // const link = document.createElement("a");
    //           // link.href = url;
    //           // link.setAttribute("download", "file.gltf"); //or any other extension
    //           // document.body.appendChild(link);
    //           // link.click();

    //           this.overlayP1 = false;
    //         })
    //         .catch((error) => {
    //           console.log(error);
    //           //this.errored = true;

    //           this.overlayP1 = false;
    //         });

    //       this.overlayP1 = false;
    //       console.log("SUCCESS!!");
    //     })
    //     .catch((error) => {
    //       console.log("Failure!!");
    //       console.log(error.status);

    //       this.overlayP1 = false;
    //     });

    //   this.overlayP1 = true;
    // },

    submitMtlFile() {
      if (this.mtlFile) {
        let formData = new FormData();
        formData.append("fileobj", this.file, "file.obj");
        formData.append("filemtl", this.mtlFile, "file.mtl");
        this.obj2gltf(formData);
        this.mtlFileValue = false;
      } else {
        let formData = new FormData();
        formData.append("fileobj", this.file, "file.obj");

        this.obj2gltf(formData);
        this.mtlFileValue = false;
      }
    },
    //obj2glb from node server
    obj2glb() {
      this.overlayP4 = true;

      let formData = new FormData();

      formData.append("fileobj", this.objFile, this.fileUploadName);

      axios
        .post("/node/api/convertobjtoglb/", formData, {
          ///node/api/compressFile/
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);
          //late added
          axios
            .get("/node/foo/file/glb/" + response.data, {
              responseType: "arraybuffer",
              headers: {
                "Content-Type": "application/octet-stream",
              },
            })
            .then((response) => {
              console.log("checkFile");
              console.log(response.data);
              this.file = new File([response.data], "fileglb.glb");

              this.extention = "glb";
              this.fileName = this.fileUploadName;
              this.fileSize = this.file.size;
              this.fileSizeCalc();

              //const url = window.URL.createObjectURL(new Blob([response.data]));
              const url = window.URL.createObjectURL(this.file);

              // model src
              let viewer = new ModelViewerElement();
              viewer = document.getElementById(
                "loading-demo-sub" + this.compoID
              );
              viewer.src = url;
              // model src

              //update thumbnail/image/png
              viewer.addEventListener("camera-change", this.Listen);

              // //working

              // const link = document.createElement("a");
              // link.href = url;
              // link.setAttribute("download", "file.gltf"); //or any other extension
              // document.body.appendChild(link);
              // link.click();

              this.overlayP4 = false;
            })
            .catch((error) => {
              console.log(error);
              //this.errored = true;

              this.overlayP4 = false;
            });

          //this.overlayP1 = false;
          console.log("SUCCESS!!");
        })
        .catch((error) => {
          console.log("Failure!!");
          console.log(error.status);

          this.overlayP4 = false;
        });
    },
    obj2glbM() {
      this.overlayP1 = true;

      let formData = new FormData();

      formData.append("fileobj", this.objFile, this.fileUploadName);
      formData.append("filemtl", this.mtlFile, this.fileUploadName);
      //formData.append("filebmp", this.bmpFile, this.fileUploadName);

      axios
        .post("/node/api/convertobjtoglbM/", formData, {
          ///node/api/compressFile/
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);
          //late added
          axios
            .get("/node/foo/file/glb/" + response.data, {
              responseType: "arraybuffer",
              headers: {
                "Content-Type": "application/octet-stream",
              },
            })
            .then((response) => {
              console.log("checkFile");
              console.log(response.data);
              this.file = new File([response.data], "fileglb.glb");

              //const url = window.URL.createObjectURL(new Blob([response.data]));
              const url = window.URL.createObjectURL(this.file);

              // model src
              let viewer = new ModelViewerElement();
              viewer = document.getElementById(
                "loading-demo-sub" + this.compoID
              );
              viewer.src = url;
              // model src

              // //working

              // const link = document.createElement("a");
              // link.href = url;
              // link.setAttribute("download", "file.gltf"); //or any other extension
              // document.body.appendChild(link);
              // link.click();

              this.overlayP1 = false;
            })
            .catch((error) => {
              console.log(error);
              //this.errored = true;

              this.overlayP1 = false;
            });

          //this.overlayP1 = false;
          console.log("SUCCESS!!");
        })
        .catch((error) => {
          console.log("Failure!!");
          console.log(error.status);

          this.overlayP1 = false;
        });
    },

    fbx2glb() {
      this.overlayP4 = true;

      let formData = new FormData();
      console.log(this.fbxFile);
      console.log(this.fileUploadName);
      formData.append("filefbx", this.fbxFile, this.fileUploadName);

      axios
        .post("/node/api/convertfbxtoglb/", formData, {
          ///node/api/compressFile/
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);

          //late added
          axios
            .get("/node/foo/file/glb/" + response.data, {
              responseType: "arraybuffer",
              headers: {
                "Content-Type": "application/octet-stream",
              },
            })
            .then((response) => {
              console.log("checkFile");
              console.log(response.data);

              this.file = new File([response.data], "fileglb.glb");
              //const url = window.URL.createObjectURL(new Blob([response.data]));
              const url = window.URL.createObjectURL(this.file);

              // model src
              let viewer = new ModelViewerElement();
              viewer = document.getElementById(
                "loading-demo-sub" + this.compoID
              );
              viewer.src = url;
              // model src

              //working

              // const link = document.createElement("a");
              // link.href = url;
              // link.setAttribute("download", "file.glb"); //or any other extension
              // document.body.appendChild(link);
              // link.click();

              this.overlayP4 = false;
            })
            .catch((error) => {
              console.log(error);
              //this.errored = true;

              this.overlayP4 = false;
            });

          //this.overlayP4 = false;
          console.log("SUCCESS!!");
        })
        .catch((error) => {
          console.log("Failure!!");
          console.log(error.status);

          this.overlayP4 = false;
        });
    },

    // obj2gltf(formData)
    obj2gltf() {
      let formData = new FormData();
      formData.append("fileobj", this.file, "file.obj");

      axios
        .post("/node/api/convertobjtogltf/", formData, {
          ///node/api/compressFile/
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);
          //late added
          axios
            .get("/node/foo/file/gltf/" + response.data, {
              responseType: "arraybuffer",
              headers: {
                "Content-Type": "application/octet-stream",
              },
            })
            .then((response) => {
              console.log("checkFile");
              console.log(response.data);
              this.fileGLTF = new Blob([response.data]);

              const url = window.URL.createObjectURL(new Blob([response.data]));

              // model src
              let viewer = new ModelViewerElement();
              viewer = document.getElementById(
                "loading-demo-sub" + this.compoID
              );
              viewer.src = url;
              // model src

              // //working

              // const link = document.createElement("a");
              // link.href = url;
              // link.setAttribute("download", "file.gltf"); //or any other extension
              // document.body.appendChild(link);
              // link.click();

              this.overlayP1 = false;
            })
            .catch((error) => {
              console.log(error);
              //this.errored = true;

              this.overlayP1 = false;
            });

          this.overlayP1 = false;
          console.log("SUCCESS!!");
        })
        .catch((error) => {
          console.log("Failure!!");
          console.log(error.status);

          this.overlayP1 = false;
        });

      this.overlayP1 = true;
    },
    fbx2gltf() {
      let formData = new FormData();
      formData.append("filefbx", this.file, "file.fbx");

      axios
        .post("/node/api/convertfbxtogltf/", formData, {
          ///node/api/compressFile/
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);

          //late added
          axios
            .get("/node/foo/file/" + response.data, {
              responseType: "arraybuffer",
              headers: {
                "Content-Type": "application/octet-stream",
              },
            })
            .then((response) => {
              console.log("checkFile");
              console.log(response.data);
              this.fileGLTF = new Blob([response.data]);

              const url = window.URL.createObjectURL(new Blob([response.data]));

              // model src
              let viewer = new ModelViewerElement();
              viewer = document.getElementById(
                "loading-demo-sub" + this.compoID
              );
              viewer.src = url;
              // model src

              //working

              // const link = document.createElement("a");
              // link.href = url;
              // link.setAttribute("download", "file.glb"); //or any other extension
              // document.body.appendChild(link);
              // link.click();

              this.overlayP1 = false;
            })
            .catch((error) => {
              console.log(error);
              //this.errored = true;

              this.overlayP1 = false;
            });

          //it was working to glb2gltf
          // axios
          //   .get(
          //     "/node/api/convertglbtogltflink/" +
          //       response.data
          //   )
          //   .then((response) => {
          //     console.log("checkFile");
          //     console.log(response.data);

          //     this.overlayP1 = false;
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //     //this.errored = true;

          //     this.overlayP1 = false;
          //   });

          this.overlayP1 = false;
          console.log("SUCCESS!!");
        })
        .catch((error) => {
          console.log("Failure!!");
          console.log(error.status);

          this.overlayP1 = false;
        });

      this.overlayP1 = true;
    },

    async addFileToServer() {
      // if (this.$refs["form"]) {
      //   this.$refs.form.resetValidation();
      // }

      //console.log(this.importType);

      if (!this.fileName) {
        this.error = true;
        this.errorMsg = "*Name filed is required!";
        return;
      }

      let { model } = this.$refs.model;
      if (!model) {
        this.error = true;
        this.errorMsg = "*File is required!";
        return;
      }

      //to make glb preview
      this.overlayP5 = true;

      let options;

      if (this.extention === "glb" || this.extention === "gltf") {
        if (model.modelLoad.animations) {
          options = {
            binary: true,
            animations: model.modelLoad.animations,
          };
        } else {
          options = {
            binary: true,
          };
        }
      } else {
        options = {
          binary: true,
        };
      }

      let result = await this.generateGLTF(model.scene, options);

      //working for blob
      let blobglb = this.makeGLTFBlob(result);

      //var fileglb = new File([result], this.fileName);

      let filepng = await fetch(this.base64).then((r) => r.blob());

      // //fileSize
      let fileSize = "" + (this.fileSize / (1024 * 1024)).toFixed(2) + "MB";

      let formData = new FormData();

      // formData.append(
      //   "fileglb",
      //   blobglb,
      //   this.fileName + "." + this.extention.toLowerCase()
      // );
      formData.append("fileglb", blobglb, this.fileName + "." + "glb");

      formData.append("filepng", filepng, this.fileName + ".png");
      //added extension in the name of file
      formData.append("filename", this.fileName);
      formData.append("filetype", this.extention);

      formData.append("description", this.filedescription);

      formData.append("state", this.selectedStatus.title);
      //formData.append("state", this.selected);

      formData.append("tags", this.serverTags);

      //previous tags were working with this
      //formData.append("tags", this.selectedTag);

      formData.append("filesize", fileSize);
      formData.append("linkHDR", "");
      formData.append("fileusdz", "");

      formData.append("fileOriginal", "");
      formData.append("fileBin", "");
      formData.append("fileMtl", "");

      formData.append("fileConfig", null);

      //progress Manager
      this.$store.commit("setActivateshowUpload", true);
      this.$store.commit("setUploadAssetFormData", formData);
      this.goBackToFiles();
    },

    async fetchAndAssignFile() {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub" + this.compoID);
      const glTF = await viewer.exportScene();
      this.filee = new File([glTF], "tempppp.glb");

      /*
      let formData = new FormData();

      formData.append("fileglb", this.filee);
      formData.append("filepng", this.imageBlob, this.fileName);
      formData.append("filename", this.fileName);
      formData.append("filetype", this.extention);

      formData.append("description", this.filedescription);

      formData.append("state", this.selected);
      formData.append("tags", this.selectedTag);

      axios
        .post(this.$abServerPath + "/api/glbfiles/glbpostfile/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function () {
          //viewer.src = "static/images/" + this.fileName;
          this.$router.push({ path: "/assets" });
          console.log("SUCCESS!!");
        })
        .catch((error) => {
          console.log(error.status);
          //console.log("ffff");
          this.$router.push({ path: "/assets" });
        });

        */
    },

    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      console.log(this.$sidebar.showSidebar);
    },

    changeStatus(item) {
      var i;
      var len;
      var index = this.localStatus.findIndex((x) => x.title === item.title);

      for (i = 0, len = this.localStatus.length; i < len; i++) {
        if (i === index) {
          this.localStatus[i].value = true;
          this.selectedStatus = this.localStatus[i];
        } else {
          this.localStatus[i].value = false;
        }
      }
    },

    getStateColor(state) {
      if (state === "inProgress") return "light-blue";
      else if (state === "onHold") return "red";
      else if (state === "complete") return "green";
      else if (state === "inQueue") return "orange";
      else return "green";
    },

    getTagsColor(tags) {
      if (tags === "priority") return "red";
      else if (tags === "urgent") return "light-blue";
      else if (tags === "share") return "green";
      else if (tags === "fix") return "orange";
      else return "green";
    },

    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    toggleFullScreen() {
      this.$refs["fullscreen"].toggle(); // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },

    goBackToFiles() {
      this.$router.push({ path: "/assets" });
      // if (this.editorR === true) {
      //   this.$router.push({ path: "/assets" });
      // } else if (this.batch === true) {
      //   return;
      // } else {
      //   this.$router.push({ path: "/assets" });
      // }
    },

    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;

      if (this.fullscreen === true) {
        document.getElementById(
          "loading-demo-sub" + this.compoID
        ).style.minHeight = "100vh";
      } else {
        document.getElementById(
          "loading-demo-sub" + this.compoID
        ).style.minHeight = "50vh";
      }
    },

    animationSelected(x) {
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub" + this.compoID);
      if (viewer) {
        viewer["animationName"] = x;
      }
    },

    async modelDownload(binary) {
      let options = {
        binary: binary,
        trs: true,
        onlyVisible: true,
        maxTextureSize: 1024,
        forcePowerOfTwoTextures: true,
        includeCustomExtensions: false,
        embedImages: true,
      };
      console.log("download");
      let viewer = new ModelViewerElement();
      viewer = document.getElementById("loading-demo-sub" + this.compoID);
      if (viewer) {
        const glTF = await viewer.exportScene(options);
        var file = new File([glTF], binary ? "export.glb" : "export.gltf");
        var link = document.createElement("a");
        link.download = file.name;
        link.href = URL.createObjectURL(file);
        link.click();
      }
    },

    downloadFiles() {
      var len;
      var i;

      len = this.downloadFileItems.length - 1;
      for (i = len; i >= 0; i--) {
        if (
          this.downloadFileItems[i]["title"] === "Original GLB File" &&
          this.downloadFileItems[i]["value"] === true
        ) {
          console.log("original glb file");

          let viewer = new ModelViewerElement();
          viewer = document.getElementById("loading-demo-sub" + this.compoID);

          if (viewer) {
            var link = document.createElement("a");
            link.download = "" + this.fileName + ".glb";
            //link.download = "Original";
            link.href = viewer.src;
            link.click();
          }
        }
        if (
          this.downloadFileItems[i]["title"] === "GLB File" &&
          this.downloadFileItems[i]["value"] === true
        ) {
          console.log("glb file");

          this.modelDownload(true);
        }
        if (
          this.downloadFileItems[i]["title"] === "GLTF File" &&
          this.downloadFileItems[i]["value"] === true
        ) {
          console.log("GLTF File");
          this.modelDownload(false);
        }
        if (
          this.downloadFileItems[i]["title"] === "USDZ File" &&
          this.downloadFileItems[i]["value"] === true
        ) {
          console.log("USDZ File");
        }
      }
    },

    checkImportValues(item) {
      var index = this.importFileItems.findIndex((x) => x.value === item.value);
      var i;
      var len;
      for (i = 0, len = this.importFileItems.length; i < len; i++) {
        if (index === i) {
          this.importFileItems[i].checked = true;
        } else {
          this.importFileItems[i].checked = false;
        }
      }
      if (this.importFileItems[index].value === "draco") {
        this.importType = "draco";
      } else {
        this.importType = "original";
      }
    },

    checkQualityValues(item) {
      var index = this.quality.findIndex((x) => x.title === item.title);
      var i;
      var len;
      for (i = 0, len = this.quality.length; i < len; i++) {
        if (index === i) {
          this.quality[i].checked = true;
        } else {
          this.quality[i].checked = false;
        }
        this.compressionSetting.title = this.quality[index].title;
        this.compressionSetting.value = this.quality[index].value;
      }
    },

    //start settings functions
    //   1st btn
    lightf() {
      this.lightbutton = true;
      this.circlebutton = false;
      this.mediabutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
    },

    //   2nd btn
    circlef() {
      this.circlebutton = true;
      this.lightbutton = false;
      this.mediabutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
    },

    //3rd btn
    mediaf() {
      this.mediabutton = true;
      this.lightbutton = false;
      this.circlebutton = false;
      this.boxbtncard = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
    },

    //4th btn
    colorbtnf() {
      this.colorbtncard = true;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.boxbtncard = false;
      this.filebtncard = false;
      this.photobtncard = false;
    },

    //5th btn
    boxbtnf() {
      this.boxbtncard = true;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
      this.filebtncard = false;
      this.colorbtncard = false;
      this.photobtncard = false;
    },
    //6th btn
    filebtnf() {
      this.filebtncard = true;
      this.boxbtncard = false;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
      this.colorbtncard = false;
      this.photobtncard = false;
    },
    // 7th btn
    photobtnf() {
      this.photobtncard = true;
      this.filebtncard = false;
      this.boxbtncard = false;
      this.mediabutton = false;
      this.lightbutton = false;
      this.circlebutton = false;
      this.colorbtncard = false;
    },

    colorf(x) {
      alert(x.color);
    },
    //end settings functions

    //file size function
    fileSizeCalc() {
      var i;
      var len;

      for (i = 0, len = this.importFileItems.length; i < len; i++) {
        if (this.importFileItems[i].value === "original") {
          this.importFileItems[i].size =
            "" + (this.fileSize / (1024 * 1024)).toFixed(2) + "MB";
        } else if (this.importFileItems[i].value === "draco") {
          this.importFileItems[i].size =
            "" + (this.fileSize / (1024 * 1024)).toFixed(2) + "MB" + "/4*";
        }
      }
    },

    changeSelectedImageFormat(item) {
      this.selectedImageFormat = "." + item.text.toLowerCase();
    },

    changeSelectedImageResolution(item) {
      this.selectedImageResolution = item.text.toLowerCase();
    },

    //remesh
    remeshObj() {
      let formData = new FormData();

      console.log(this.fileName);
      console.log(this.file);
      console.log(this.extention);

      // formData.append(
      //   "fileremeshzip",
      //   this.file,
      //   this.file.name.replace(/\.[^/.]+$/, "") +
      //     "." +
      //     this.extention.toLowerCase()
      // );
      formData.append("fileremeshzip", this.file, this.file.name);

      axios
        .post(
          this.$abServerPath + "/api/glbfiles/glbpostremeshfile/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
            onUploadProgress: function (progressEvent) {
              this.uploadPercentage = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            }.bind(this),
          }
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.error) {
            console.log(response.data.error);
          }
          console.log("SUCCESS!!");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    makeGLTFBlob(result) {
      if (result instanceof ArrayBuffer) {
        let glb = new Blob([result], {
          type: "application/octet-stream",
        });
        return glb;
      } else {
        const output = JSON.stringify(result, null, 2);
        let gltf = new Blob([output], { type: "text/plain" });
        return gltf;
      }
    },

    async generateGLTF(input, options) {
      const gltfExporter = new GLTFExporter();
      // const options = {
      //   //trs: document.getElementById( 'option_trs' ).checked,
      //   //onlyVisible: document.getElementById( 'option_visible' ).checked,
      //   //truncateDrawRange: document.getElementById( 'option_drawrange' ).checked,
      //   binary: binaryBool,
      //   animations: animations,
      //   //maxTextureSize: Number( document.getElementById( 'option_maxsize' ).value ) || Infinity // To prevent NaN value
      // };
      // let saveArrayBuffer = this.saveArrayBuffer;
      // let saveString = this.saveString;
      //let save = this.save;
      return new Promise((resolve) =>
        gltfExporter.parse(input, resolve, options)
      );

      // console.log("wewe");
      // console.log(result);

      // let glbBlob = this.glbBlob;
      // let glbblob = await new Promise((resolve) => glbBlob(result, resolve));
      // console.log("ryryryrt");
      // console.log(glbblob);
      // return glbblob;

      //return glb;
    },

    exportGLTF(input, binaryBool) {
      const gltfExporter = new GLTFExporter();

      const options = {
        //trs: document.getElementById( 'option_trs' ).checked,
        //onlyVisible: document.getElementById( 'option_visible' ).checked,
        //truncateDrawRange: document.getElementById( 'option_drawrange' ).checked,
        binary: binaryBool,
        //maxTextureSize: Number( document.getElementById( 'option_maxsize' ).value ) || Infinity // To prevent NaN value
      };
      let saveArrayBuffer = this.saveArrayBuffer;
      let saveString = this.saveString;
      gltfExporter.parse(
        input,
        function (result) {
          if (result instanceof ArrayBuffer) {
            saveArrayBuffer(result, "scene.glb");
          } else {
            const output = JSON.stringify(result, null, 2);
            //console.log(output);
            saveString(output, "scene.gltf");
          }
        },
        options
      );
    },
    save(blob, filename) {
      var link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },
    saveString(text, filename) {
      this.save(new Blob([text], { type: "text/plain" }), filename);
    },
    saveArrayBuffer(buffer, filename) {
      this.save(
        new Blob([buffer], { type: "application/octet-stream" }),
        filename
      );
    },

    cloneCanvas(oldCanvas) {
      //create a new canvas
      var newCanvas = document.createElement("canvas");
      var context = newCanvas.getContext("2d");

      //set dimensions
      newCanvas.width = 495;
      newCanvas.height = 495;

      //apply the old canvas to the new one
      context.drawImage(oldCanvas, 0, 0);

      //return the new canvas
      return newCanvas;
    },

    resizedataURL(datas, wantedWidth, wantedHeight) {
      return new Promise(function (resolve) {
        // We create an image to receive the Data URI
        var img = document.createElement("img");

        // When the event "onload" is triggered we can resize the image.
        img.onload = function () {
          // We create a canvas and get its context.
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");

          // We set the dimensions at the wanted size.
          canvas.width = wantedWidth;
          canvas.height = wantedHeight;

          // We resize the image with the canvas method drawImage();
          ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

          var dataURI = canvas.toDataURL();

          // This is the return of the Promise
          resolve(dataURI);
        };

        // We put the Data URI in the image's src attribute
        img.src = datas;
      });
    },

    resizeImage(base64Str, maxWidth = 490, maxHeight = 490) {
      return new Promise((resolve) => {
        let img = new Image();
        img.src = base64Str;
        img.onload = () => {
          let canvas = document.createElement("canvas");
          const MAX_WIDTH = maxWidth;
          const MAX_HEIGHT = maxHeight;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }
          canvas.width = width;
          canvas.height = height;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL());
        };
      });
    },
    myTestFunc1() {},
  },
};
</script>



<style lang="scss" scoped>
@import "../assets/scss/material-dashboard.scss";

.mainARview {
  position: relative;
  background-image: radial-gradient(#808080, #262626);
}

.textARview {
  top: 0;
  left: 0;
  width: 100%;

  text-align: center;
  color: white;
  font-size: 12px;

  cursor: pointer;
  font-family: "Raleway";

  position: absolute;
}

.mainARview1 {
  position: relative;
  background-image: radial-gradient(white, #808080);
}

.textARview1 {
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  color: #444444;
  font-size: 12px;

  cursor: pointer;
  font-family: "Raleway";

  position: absolute;
}

.drop-zone {
  width: 100%;

  min-height: 20vh;
  cursor: pointer;
}

.drop-zone--over {
  border-style: solid;
}

.drop-zone__input {
  display: none;
}

.drop-zone__thumb {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100vh;
  min-height: 100vh;
}

.drop-zone__thumb::after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 0;

  font-size: 14px;
  text-align: center;
}
.drop-zone__prompt {
  font-size: 50px;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
.expand::-webkit-scrollbar {
  width: 5px;
}
.expand {
  overflow-y: scroll;
  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
}
.expand::-webkit-scrollbar-track {
  background: transparent;
}
.expand::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 10px;
}

// .v-text-field--outlined >>> fieldset {
//   border-color: #ccc;
// }
// .v-text-field--outlined:hover >>> fieldset {
//   -moz-box-shadow: 0 0 10px #ccc;
//   -webkit-box-shadow: 0 0 10px #ccc;
//   box-shadow: 0 0 10px #ccc;
// }
::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}
::v-deep .v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none;
}
// ::v-deep .v-text-field {
//   height: 10px !important;
// }

.hdrNavigation {
  top: 0;
  left: 0;
  z-index: 100;
  background-color: transparent;
  position: absolute;
  font-family: "Nunito Sans";
}
.expand1 {
  overflow-y: auto !important;
  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
  overflow-x: hidden;
}

.expand1::-webkit-scrollbar {
  width: 3px;
}

.expand1::-webkit-scrollbar-track {
  background: transparent;
}
.expand1::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 10px;
}
</style>

